///////////////////////////////////////////////////////////////////////////////////
// Retrieve NOUS API Key
////////////////////////////////////////////////////////////////////////////////////
var nous_api_data;

////////////////////////////////////////////////////////////////////////////////////
// Marketo (Munchkin) virtual page view for the AJAX home-designs filter
// Emits a "Visit Web Page" to Marketo when a filter settles, so the Land Type
// Interest "Add Members" triggers can qualify without a real page reload.
// Trailing-debounced (collapses rapid changes, e.g. stepping bedrooms 3 -> 5) and
// de-duped against the last view sent. Munchkin loads via GTM and may be absent
// (e.g. non-prod), so we guard on it.
////////////////////////////////////////////////////////////////////////////////////
window.hhEmitMunchkinFilterView = (function () {
  var timer, lastSig = '';
  return function (path, queryString) {
    if (!queryString) { return; }
    clearTimeout(timer);
    timer = setTimeout(function () {
      var sig = path + '?' + queryString;
      if (sig === lastSig) { return; }
      lastSig = sig;
      if (window.Munchkin && typeof window.Munchkin.munchkinFunction === 'function') {
        window.Munchkin.munchkinFunction('visitWebPage', { url: path, params: queryString });
      }
    }, 800);
  };
})();

////////////////////////////////////////////////////////////////////////////////////
// Persistant Session Storage
////////////////////////////////////////////////////////////////////////////////////
if (!sessionStorage.length) {
  // Ask other tabs for session storage
  localStorage.setItem('getSessionStorage', Date.now());
};

window.addEventListener('storage', function(event) {

  if (event.key == 'getSessionStorage') {

    localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
    localStorage.removeItem('sessionStorage');

  } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
    // sessionStorage is empty -> fill it

    var data = JSON.parse(event.newValue),
          value;

    for (key in data) {
      sessionStorage.setItem(key, data[key]);
    }

  }
});

////////////////////////////////////////////////////////////////////////////////////
// Map stylers used throughout site
////////////////////////////////////////////////////////////////////////////////////
var mapStyle = [
	{
		"featureType": "administrative",
		"elementType": "labels.text.fill",
		"stylers": [
			{
				"color": "#444444"
			}
		]
	},
	{
		"featureType": "landscape",
		"elementType": "all",
		"stylers": [
			{
				"color": "#ecf0f4"
			}
		]
	},
	{
		"featureType": "poi",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road",
		"elementType": "all",
		"stylers": [
			{
				"saturation": -100
			},
			{
				"lightness": 45
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			},
			{
				"color": "#ff0000"
			}
		]
	},
	{
		"featureType": "road.highway",
		"elementType": "labels",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "road.arterial",
		"elementType": "labels.icon",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "transit",
		"elementType": "all",
		"stylers": [
			{
				"visibility": "off"
			}
		]
	},
	{
		"featureType": "water",
		"elementType": "all",
		"stylers": [
			{
				"color": "#19325a"
			},
			{
				"visibility": "on"
			}
		]
	}
];

////////////////////////////////////////////////////////////////////////////////////
// Header Offset
////////////////////////////////////////////////////////////////////////////////////
function getHeaderOffset() {

  ////////////////////////////////////////////////////////////////////////////////////
  // Variables
  ////////////////////////////////////////////////////////////////////////////////////
  var headerOuterHeight = 0;

  ////////////////////////////////////////////////////////////////////////////////////
  // Get Sticky Header Outer Height
  ////////////////////////////////////////////////////////////////////////////////////
  // if (jQuery('header').hasClass('js-sticky-top')) {
  headerOuterHeight = jQuery('header').outerHeight() + 20;
  // }

  ////////////////////////////////////////////////////////////////////////////////////
  // Return Header Outer Height
  ////////////////////////////////////////////////////////////////////////////////////
  return headerOuterHeight;

}

////////////////////////////////////////////////////////////////////////////////////
// NOUS Anchor Link Hash
////////////////////////////////////////////////////////////////////////////////////
function nous_anchor_link_hash(hash) {
  // Exclude "Chosen" (https://harvesthq.github.io/chosen/) dropdowns from hash scroll
  // as they are not compatible with the scroll to hash functionality
  // - no hash present, results in a JS error
  if (jQuery(this).hasClass('chosen-single') || jQuery(this).hasClass('js-zoom-control')) {
    return;
  }

  // Fixed Nav Offset
  var header_offset = getHeaderOffset();

  // Scroll to w/ Animation
  if(jQuery('*[data-scroll-element="' + hash + '"]').length) {
    jQuery('html, body').animate({
      scrollTop: jQuery('*[data-scroll-element="' + hash + '"]').offset().top - header_offset
    }, 0);
  }
}

////////////////////////////////////////////////////////////////////////////////////
// Sticky Header
////////////////////////////////////////////////////////////////////////////////////
function sticky_scroll_header() {
  var lastScrollTop = 0;
  jQuery(window).scroll(function () {
    set_sticky_scroll_header_position()
  });
}

function set_sticky_scroll_header_position(){
  const header = jQuery("body").find('header');
  const scroll = jQuery(window).scrollTop();
  if (scroll >= 20) {
    if(!header.hasClass('scrolled')){
      header.addClass("scrolled");
    }
  }else{
    if(header.hasClass('scrolled')){
      header.removeClass("scrolled");
    }
  }
}
jQuery( document ).ready(function($) { 
  set_sticky_scroll_header_position(); 
});



////////////////////////////////////////////////////////////////////////////////////
// Responsive Equal Heights
////////////////////////////////////////////////////////////////////////////////////
function responsiveEqualHeights() {
  var maxHeight = 0;

  jQuery('.js-resp-equal-heights').css('height', 'auto');
  jQuery('.js-resp-equal-heights').each(function(index) {
    jQuery(this).each(function(index) {
      if(jQuery(this).height() > maxHeight) {
        maxHeight = jQuery(this).height();
      }
    });
  });
  jQuery('.js-resp-equal-heights').height(maxHeight);
}
jQuery(window).bind("load", responsiveEqualHeights);
jQuery(window).bind("resize", responsiveEqualHeights);

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Flip Cards Module
////////////////////////////////////////////////////////////////////////////////////
function flexi_flip_cards_module() {
  (function($) {
    var flexi_multi_col_block = $('.section-flexi-multi-column-content');
    var flexi_explore_the_range = $('.section-flexi-explore-the-range');
    flexi_multi_col_block.each(function() {
      $(this).find('.js-trigger-flip').on('click', function() {
        $(this).toggleClass('flipped');
      });
    });
    flexi_explore_the_range.each(function() {+
      
      $(this).find('.js-trigger-flip')
      .on('mouseenter', function () {
        $(this).addClass('flipped');
      })
      .on('mouseleave', function () {
        $(this).removeClass('flipped');
      });

    });
  })(jQuery);
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Virtual Tour Block
////////////////////////////////////////////////////////////////////////////////////
function flexi_virtual_tour_block() {
  (function($) {

    // Helper function to initialize virtual tour functionality for any section
    function initVirtualTours(sectionSelector, sectionClass) {
      var sections = $(sectionSelector);
      sections.each(function() {
        var section = $(this);

        // Virtual tour click handler
        section.find('.js-virtual-tour').on('click', function () {
          $(this).find('.js-tour-info').addClass('d-none');
          $(this).find('.js-tour-placeholder-image').addClass('d-none');
        });

        // Dropdown change handler
        section.find('.js-hd-virtual-tours').on('change', function (e) {
          e.preventDefault();
          var selectedValue = $(this).val();
          var section = $(this).closest(sectionClass);

          // Remove active class from all virtual tours in this section
          section.find('.js-virtual-tour').each(function() {
            $(this).removeClass('active');
          });

          // Add active class to the selected virtual tour
          section.find(`.js-virtual-tour#${selectedValue}`).addClass('active');
        });
      });
    }

    // Initialize both types of virtual tour sections
    initVirtualTours('.section-flexi-virtual-tour-block', '.section-flexi-virtual-tour-block');
    initVirtualTours('.section-hd-virtual-tour', '.section-hd-virtual-tour');

  })(jQuery);
}
////////////////////////////////////////////////////////////////////////////////////


////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Display video Block
////////////////////////////////////////////////////////////////////////////////////
function flexi_display_video_block() {
  (function($) {

    // Helper function to initialize virtual tour functionality for any section
    function initVirtualTours(sectionSelector, sectionClass) {
      var sections = $(sectionSelector);
      sections.each(function() {
        var section = $(this);

        // Virtual tour click handler
        section.find('.js-display-video').on('click', function () {
          $(this).find('.js-display-video-info').addClass('d-none');
          //$(this).find('.js-dicplay-videoplaceholder-image').addClass('d-none');
        });

        // Dropdown change handler
        section.find('.js-hd-display-videos').on('change', function (e) {
          e.preventDefault();
          var selectedValue = $(this).val();
          var section = $(this).closest(sectionClass);

          // Remove active class from all virtual tours in this section
          section.find('.js-display-video').each(function() {
            $(this).removeClass('active');
          });

          // Add active class to the selected virtual tour
          section.find(`.js-display-video#${selectedValue}`).addClass('active');
        });
      });
    }

    // Initialize both types of virtual tour sections
    initVirtualTours('.section-flexi-display-video-block', '.section-flexi-display-video-block');
    initVirtualTours('.section-hd-display-video', '.section-hd-display-video');

  })(jQuery);
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Virtual Tour Block
////////////////////////////////////////////////////////////////////////////////////
function flexi_video_block() {
  (function($) {

    var flexi_video_block = $('.section-flexi-video-block');

    flexi_video_block.each(function() {
      $(this).find('.js-video-block').on('click', function () {
        $(this).find('.js-video-placeholder-image').addClass('d-none');
      });
    });

  })(jQuery);
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Ticker Tape
////////////////////////////////////////////////////////////////////////////////////
function flexi_ticker_tape(wrapperClass) {
  const containers = document.querySelectorAll(wrapperClass);

  if (!containers) return; // Exit if the containers is not found

  containers.forEach(container => {
    var parentContainer = container.parentNode;
    const textContent = container.innerHTML;

    let duplicateContent = '';
    let duplicatesNeeded = 0;

    let tapeDirection = container.getAttribute('data-tape-direction');

    let currentPosition = - (container.offsetWidth / 2);

    // Determine how many duplicates are needed based on parentContainer's width
    if (tapeDirection === "left") {
      duplicatesNeeded = Math.ceil(parentContainer.offsetWidth / container.offsetWidth);
    } else if (tapeDirection === "right") {
      duplicatesNeeded = Math.ceil(parentContainer.offsetWidth / container.offsetWidth);
    }

    for (let i = 0; i < duplicatesNeeded; i++) {
      duplicateContent += textContent;
    }

    // Set the duplicated content
    container.innerHTML = duplicateContent;

    const speed = 1; // Adjust speed: higher is slower
    let animationFrameId;

    function animateScroll() {
      if (tapeDirection === "left") {
        currentPosition += speed;
        if (currentPosition >= parentContainer.offsetWidth) {
          currentPosition = - 0;
        }
        container.style.transform = `translate3d(${currentPosition}px, 0, 0)`;
      } else if (tapeDirection === "right") {
        currentPosition -= speed;
        if (currentPosition <= -parentContainer.offsetWidth) {
          currentPosition = 0;
        }
        container.style.transform = `translate3d(${currentPosition}px, 0, 0)`;
      }

      animationFrameId = requestAnimationFrame(animateScroll); // Smooth animation
    }

    // Function to pause animation
    function pauseAnimation() {
      cancelAnimationFrame(animationFrameId);
    }

    // Function to resume animation
    function resumeAnimation() {
      animateScroll();
    }

    // Event listeners to pause and resume animation on hover and touch
    // ['mouseenter', 'touchstart'].forEach(event => {
    //   container.addEventListener(event, pauseAnimation);
    // });

    // ['mouseleave', 'touchend'].forEach(event => {
    //   container.addEventListener(event, resumeAnimation);
    // });

    animateScroll(); // Start the animation

  });
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Virtual Tour Block
////////////////////////////////////////////////////////////////////////////////////
function flexi_harmony_inclusions() {
  (function($) {

    var flexi_harmony_inclusions = $('.section-flexi-harmony-inclusions');
    flexi_harmony_inclusions.each(function() {

      $(this).find('.js-inclusion-dropdown').on('change', function () {
        var block = $(this).closest('.section-flexi-harmony-inclusions');
        var blockInclusionContents = block.find('.flexi-harmony-inclusions-content');
        var blockInclusionsContentsWrapper = blockInclusionContents.find('.js-inclusions-content');
        var selectedValue = $(this).val();
        blockInclusionsContentsWrapper.find('.inclusion-content').each(function() {
          var inclusionContent = $(this);
          var inclusionContnetId = inclusionContent.data('id');
          inclusionContent.addClass('d-none');

          if(inclusionContnetId == selectedValue) {
            inclusionContent.addClass('d-block').removeClass('d-none');

            // Refresh all Flickity carousels within the selected inclusion content
            inclusionContent.find('.flickity-enabled').each(function() {
              var $carousel = $(this);
              if ($carousel.data('flickity')) {
                $carousel.flickity('resize');
              }
            });
          } // ENDIF
        });

      });

    });

  })(jQuery);
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Sticky Filter Block
////////////////////////////////////////////////////////////////////////////////////
function sticky_filter_block() {
  (function($) {
    var filterStickyScroll = jQuery('body').find('.js-filter-sticky-scroll');

    if (filterStickyScroll.length > 0) {
      // Cache the initial position to avoid recalculating on every scroll
      var filterStickyScrollTop = filterStickyScroll.offset().top;

      function checkStickyPosition() {
        var scrollTop = jQuery(window).scrollTop();
        var headerOffset = getHeaderOffset(); // Use your existing header offset function
        headerOffset = 0;

        // Add 'scrolled' class when scrolled past the top of the element
        if (scrollTop > (filterStickyScrollTop - headerOffset)) {
          filterStickyScroll.addClass('scrolled');
        } else {
          filterStickyScroll.removeClass('scrolled');
        }
      }

      // Check position on scroll
      jQuery(window).on('scroll', checkStickyPosition);

      // Check position on page load
      checkStickyPosition();

      // Recalculate position on window resize
      jQuery(window).on('resize', function() {
        filterStickyScrollTop = filterStickyScroll.offset().top;
        checkStickyPosition();
      });
    }

  })(jQuery);
}

////////////////////////////////////////////////////////////////////////////////////
// Custom Mouse Pointer Function
////////////////////////////////////////////////////////////////////////////////////
function init_custom_mouse_pointer(selector, offsetX, offsetY) {
  selector = selector || '.js-custom-mouse-pointer';
  offsetX = offsetX || 10;
  offsetY = offsetY || 10;

  // Prevent duplicate bindings if this function is called multiple times
  jQuery(document).off('.customPointer');

  // Show on move
  jQuery(document).on('mousemove.customPointer', selector, function (event) {

    //don't activate when hovering flickity buttons or expand button
    if (jQuery(event.target).closest('.flickity-prev-next-button, .js-fp-expand-btn').length) {
      jQuery(this).find('.js-hover-text').removeClass('active');
      return;
    }

    var $container = jQuery(this);
    var $hover = $container.find('.js-hover-text');
    
    $hover.addClass('active');

    var containerOffset = $container.offset();
    var mouseX = event.pageX - containerOffset.left;
    var mouseY = event.pageY - containerOffset.top;

    $hover.css({
      left: mouseX + offsetX,
      top: mouseY + offsetY,
      'z-index': 2
    });
  });

  // Hide on leave
  jQuery(document).on('mouseleave.customPointer', selector, function () {
    jQuery(this).find('.js-hover-text').removeClass('active');
  });
}

jQuery(document).on('mousemove', '.flickity-prev-next-button', function () {
  jQuery(this).closest('.js-custom-mouse-pointer')
    .find('.js-hover-text')
    .removeClass('active');
});

jQuery(document).on('mouseleave', '.flickity-prev-next-button', function () {
  jQuery(this).closest('.js-custom-mouse-pointer')
    .find('.js-hover-text')
    .addClass('active');
});

////////////////////////////////////////////////////////////////////////////////////
// Add to Favourites
////////////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////////////
// Favourites module
// Consolidated logic for toggling, syncing, and removing favourites
////////////////////////////////////////////////////////////////////////////////////
/**
 * @module nousFavourites
 * Hallmark Homes Favourites module.
 *
 * Provides a robust, cross-page, client-side and cookie-synced favourites system for home designs.
 * Handles toggling of favourite state, DOM/UI updates, syncing from cookies, and event binding for all related UI elements.
 *
 * All public methods are exposed on the `window.nousFavourites` namespace.
 *
 * @namespace nousFavourites
 * @property {Function} init - Initializes all event bindings and synchronizes UI with cookie state.
 * @property {Function} toggle - Toggles a favourite state for a given home design (pid).
 * @property {Function} syncFromCookie - Forces a re-sync of all UI blocks from the current cookie state.
 * @property {Function} bindCardButtons - Binds click handlers to all "add to favourites" buttons.
 * @property {Function} bindFavouritesBlock - Binds click handlers to all "remove favourite" buttons.
 */
window.nousFavourites = (function () {
  var ajaxUrl = window.location.origin + '/wp-admin/admin-ajax.php?action=nous_favourite_designs_cookie_management';
  var cookieName = '_nous_hallmark_favourite_designs';
  var cookieLifetimeMs = 30 * 24 * 60 * 60 * 1000;
  var maxFavourites = 3;

  /**
   * Displays a message to the user when the 3-favourites limit is reached.
   * Attempts to render the message in a relevant UI container near the source element,
   * or falls back to a global message container, or alerts as last resort.
   *
   * @private
   * @param {HTMLElement} [sourceEl] - The element that triggered the limit (for contextual message placement).
   * @returns {void}
   */
  function showLimitMessage(sourceEl) {
    var message = 'You can only have 3 favourites at a time. Please remove one to add another.';

    // Try find a local message container near the triggering element
    var container = null;
    if (sourceEl && typeof sourceEl.closest === 'function') {
      container = sourceEl.closest('.js-card-search-home-designs, .js-feature-home-details, .js-flexi-home-intro-block, .js-flexi-favourite-designs-block');
    }

    if (container) {
      var local = container.querySelector('.js-favourites-limit');
      if (local) {
        local.textContent = message;
        local.classList.remove('d-none');
        return;
      }
    }

    // Fallback: first global favourites limit container if present
    var fallback = document.querySelector('.js-favourites-limit');
    if (fallback) {
      fallback.textContent = message;
      fallback.classList.remove('d-none');
      return;
    }

    // Last resort
    alert(message);
  }

  /**
   * Retrieves the current list of favourite PIDs from the favourites cookie.
   *
   * @private
   * @returns {Array<string>} Array of favourite home design post IDs (as strings).
   */
  function getCookieValues() {
    try {
      var match = document.cookie.split('; ').find(function (row) {
        return row.indexOf(cookieName + '=') === 0;
      });
      if (!match) return [];
      // Older cookies can carry backslash-escaped quotes.
      var value = decodeURIComponent(match.split('=')[1] || '').replace(/\\"/g, '"');
      var parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      console.error('Favourites cookie parse error:', e);
      return [];
    }
  }

  /**
   * Updates all "add to favourites" and "view favourites" button states across the DOM
   * to reflect the supplied favourites list.
   *
   * @private
   * @param {Array<string|number>} favourites - List of current favourite post IDs.
   * @returns {void}
   */
  function updateCardStatesFromList(favourites) {
    var favSet = Array.isArray(favourites) ? favourites.map(String) : [];

    document.querySelectorAll('.js-add-to-favourites').forEach(function (addBtn) {
      var pid = String(addBtn.getAttribute('data-hd-pid') || '');
      if (!pid) return;

      // Find the logical container for this favourites pair:
      // - search common wrappers first, then fall back to the nearest parent
      var container =
        addBtn.closest('.js-card-search-home-designs, .js-feature-home-details, .js-flexi-home-intro-block, .js-flexi-favourite-designs-block') ||
        addBtn.parentElement;

      if (!container) return;

      var viewLink = container.querySelector('.js-go-to-favourites');
      if (!viewLink) return;

      if (favSet.indexOf(pid) !== -1) {
        addBtn.classList.add('d-none');
        viewLink.classList.remove('d-none');
      } else {
        addBtn.classList.remove('d-none');
        viewLink.classList.add('d-none');
      }
    });
    updateFavouriteCountDisplay(favourites);
  }

  /**
   * Updates the UI elements that display the count of current favourites.
   * Shows/hides the badge wrapper and updates the count text.
   *
   * Expected markup:
   * <div class="favourite-count js-favourite-count-container d-none">
   *   <span class="js-favourite-count"></span>
   * </div>
   *
   * @private
   * @param {Array} favourites - Current favourites list.
   * @returns {void}
   */
  function updateFavouriteCountDisplay(favourites) {
    var count = Array.isArray(favourites) ? favourites.length : 0;

    // Toggle wrapper visibility
    document.querySelectorAll('.js-favourite-count-container').forEach(function (wrapper) {
      if (count > 0) {
        wrapper.classList.remove('d-none');
      } else {
        wrapper.classList.add('d-none');
      }

      // Update inner count span if present
      var span = wrapper.querySelector('.js-favourite-count');
      if (span) {
        span.textContent = count > 0 ? count : '';
      }
    });
  }

  /**
   * Updates all UI components related to a specific post ID (pid) after a toggle action.
   * Hides/shows "add" and "view" buttons, and removes cards from favourites block if needed.
   * Also triggers a full UI sync if the new favourites list is provided.
   *
   * @private
   * @param {string|number} pid - The post ID being updated.
   * @param {string} action - The action performed: 'added' or 'removed'.
   * @param {Array} [favourites] - The current favourites list (optional).
   * @returns {void}
   */
  function updateUIForPid(pid, action, favourites) {
    var pidStr = String(pid);

    document.querySelectorAll('.js-add-to-favourites[data-hd-pid="' + pidStr + '"]').forEach(function (btn) {
      var container =
        btn.closest('.js-card-search-home-designs, .js-feature-home-details, .js-flexi-home-intro-block, .js-flexi-favourite-designs-block') ||
        btn.parentElement ||
        btn.parentNode;
      var viewLink = container ? container.querySelector('.js-go-to-favourites') : null;

      if (action === 'added') {
        btn.classList.add('d-none');
        if (viewLink) viewLink.classList.remove('d-none');
      }

      if (action === 'removed') {
        btn.classList.remove('d-none');
        if (viewLink) viewLink.classList.add('d-none');
      }
    });

    if (action === 'removed') {
      document.querySelectorAll('.js-remove-favourite[data-hd-pid="' + pidStr + '"]').forEach(function (btn) {
        // Prefer the specific favourites card wrapper if present
        var favCard = btn.closest('.js-card-hd-favourite-wrapper-wrapper, .js-card-hd-favourite-wrapper');
        if (favCard) {
          favCard.classList.add('d-none');
          return;
        }
      });
    }

    if (Array.isArray(favourites)) {
      updateCardStatesFromList(favourites);
      updateFavouriteCountDisplay(favourites);
    }
  }

  /**
   * Writes the favourites list to the cookie in the browser, with the name,
   * encoding, path and 30-day expiry the theme has always used, so the PHP
   * readers (favourites page, info packs) see the same value.
   *
   * The write fails when the browser already holds an HttpOnly copy of the
   * cookie, which PHP used to set on a first visit. Script cannot replace
   * that copy, so the caller falls back to the server.
   *
   * @private
   * @since 1.1.0
   * @param {Array<string>} favourites - Favourite post IDs.
   * @returns {boolean} True when the cookie now holds the list.
   */
  function writeCookieValues(favourites) {
    var value = JSON.stringify(favourites);
    var expiry = new Date(Date.now() + cookieLifetimeMs);

    document.cookie = cookieName + '=' + encodeURIComponent(value) + '; expires=' + expiry.toUTCString() + '; path=/';

    return JSON.stringify(getCookieValues()) === value;
  }

  /**
   * Toggles a favourite through the server. Only used when the browser holds
   * an HttpOnly cookie that script cannot overwrite: the server replaces it
   * with a readable one, and later toggles stay in the browser.
   *
   * @private
   * @since 1.1.0
   * @param {string} pidStr - The home design post ID.
   * @param {HTMLElement} [sourceEl] - The trigger element.
   * @param {string} [mode] - 'remove' only ever removes, never adds.
   * @returns {Promise<?Object>} The AJAX payload, or null on failure.
   */
  function toggleOnServer(pidStr, sourceEl, mode) {
    var modeParam = (mode === 'remove') ? '&mode=remove' : '';
    return fetch(ajaxUrl + '&pid=' + encodeURIComponent(pidStr) + modeParam, {
      method: 'GET',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.success || !data.data) {
          console.error('Unexpected favourites response:', data);
          return null;
        }

        var payload = data.data;

        if (payload.action === 'limit_reached') {
          showLimitMessage(sourceEl);
          if (Array.isArray(payload.current_favourites)) {
            updateFavouriteCountDisplay(payload.current_favourites);
          }
          return payload;
        }

        updateUIForPid(pidStr, payload.action, payload.current_favourites);
        return payload;
      })
      .catch(function (error) {
        console.error('Favourites AJAX error:', error);
        return null;
      });
  }

  /**
   * Toggles a home design as a favourite and updates the DOM + cookie state.
   * The cookie is written in the browser, so no request is sent, except in the
   * HttpOnly case handled by toggleOnServer(). Enforces the 3-item limit.
   *
   * @public
   * @since 1.0.0
   * @param {string|number} pid - The unique post ID of the home design.
   * @param {HTMLElement} [sourceEl] - The button or trigger element initiating the action.
   * @returns {Promise<?Object>} - Resolves with { pid, action, favourites_count, current_favourites }, or null if limited/invalid.
   */
  function toggle(pid, sourceEl) {
    var pidStr = String(pid || '').trim();
    if (!/^\d+$/.test(pidStr)) {
      console.error('Missing PID for favourites toggle');
      return Promise.resolve(null);
    }

    var currentFavourites = getCookieValues().map(String);
    var alreadyFavourited = currentFavourites.indexOf(pidStr) !== -1;

    if (!alreadyFavourited && currentFavourites.length >= maxFavourites) {
      showLimitMessage(sourceEl);
      return Promise.resolve(null);
    }

    var action = alreadyFavourited ? 'removed' : 'added';
    var updated = alreadyFavourited
      ? currentFavourites.filter(function (id) { return id !== pidStr; })
      : currentFavourites.concat(pidStr);

    if (!writeCookieValues(updated)) {
      return toggleOnServer(pidStr, sourceEl);
    }

    updateUIForPid(pidStr, action, updated);

    return Promise.resolve({
      pid: pidStr,
      action: action,
      favourites_count: updated.length,
      current_favourites: updated
    });
  }

  /**
   * Removes a home design from the favourites, if it is there. Unlike
   * toggle(), it never adds, so a stale remove button cannot re-add a design
   * another tab already removed.
   *
   * @public
   * @since 1.1.0
   * @param {string|number} pid - The home design post ID.
   * @returns {void}
   */
  function remove(pid) {
    var pidStr = String(pid || '').trim();
    if (!/^\d+$/.test(pidStr)) return;

    if (getCookieValues().map(String).indexOf(pidStr) !== -1) {
      toggle(pidStr);
    } else if (!hasReadableCookie()) {
      // The list was rendered from an HttpOnly cookie script cannot see.
      toggleOnServer(pidStr, undefined, 'remove');
    }
  }

  /**
   * Whether script can see the favourites cookie at all. It cannot when the
   * browser holds the legacy HttpOnly copy.
   *
   * @private
   * @since 1.1.0
   * @returns {boolean} True when document.cookie carries the favourites cookie.
   */
  function hasReadableCookie() {
    return document.cookie.split('; ').some(function (row) {
      return row.indexOf(cookieName + '=') === 0;
    });
  }

  /**
   * Binds click event handlers to all "add to favourites" buttons in the DOM.
   * Ensures each button is only bound once.
   *
   * @public
   * @returns {void}
   */
  function bindCardButtons() {
    document.querySelectorAll('.js-add-to-favourites').forEach(function (btn) {
      if (btn.dataset.nousFavouritesBound === '1') return;
      btn.dataset.nousFavouritesBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var pid = btn.getAttribute('data-hd-pid');
        toggle(pid, btn);
      });
    });
  }

  /**
   * Binds click event handlers to all "remove favourite" buttons in the DOM.
   * Ensures each button is only bound once.
   *
   * @public
   * @returns {void}
   */
  function bindFavouritesBlock() {
    document.querySelectorAll('.js-remove-favourite').forEach(function (btn) {
      if (btn.dataset.nousFavouritesBound === '1') return;
      btn.dataset.nousFavouritesBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var pid = btn.getAttribute('data-hd-pid');
        toggle(pid, btn);
      });
    });
  }

  /**
   * Re-syncs the favourites UI for a specific card/container element.
   * This is useful when the underlying data-hd-pid changes (e.g. after
   * switching home-design variants within a family card).
   *
   * @public
   * @param {HTMLElement} containerEl - The logical wrapper for the favourites pair
   *                                    (e.g. .js-card-search-home-designs).
   * @returns {void}
   */
  function syncCard(containerEl) {
    if (!containerEl || !containerEl.querySelector) return;

    var favourites = getCookieValues();
    var favSet = Array.isArray(favourites) ? favourites.map(String) : [];

    var addBtn = containerEl.querySelector('.js-add-to-favourites');
    var viewLink = containerEl.querySelector('.js-go-to-favourites');

    if (!addBtn || !viewLink) return;

    var pid = String(addBtn.getAttribute('data-hd-pid') || '').trim();
    if (!pid) return;

    if (favSet.indexOf(pid) !== -1) {
      addBtn.classList.add('d-none');
      viewLink.classList.remove('d-none');
    } else {
      addBtn.classList.remove('d-none');
      viewLink.classList.add('d-none');
    }
  }

  /**
   * Synchronizes all relevant UI elements to match the current favourites state from the cookie.
   * Should be called after page load or after any AJAX DOM update that may have injected new favourite UI elements.
   *
   * @public
   * @returns {void}
   */
  function syncFromCookie() {
    var favourites = getCookieValues();
    updateCardStatesFromList(favourites);
    updateFavouriteCountDisplay(favourites);
  }

  /**
   * Initializes the favourites module: binds event handlers and synchronizes all UI.
   * Should be called once on page load.
   *
   * @public
   * @returns {void}
   */
  function init() {
    getCookieValues();
    bindCardButtons();
    bindFavouritesBlock();
    syncFromCookie();
  }

  return { init, toggle, remove, getCookieValues, syncFromCookie, bindCardButtons, bindFavouritesBlock, syncCard };
})();

////////////////////////////////////////////////////////////////////////////////////
// Quote List module
// Persistent "Add to Quote" tracking for home designs
////////////////////////////////////////////////////////////////////////////////////
/**
 * @module nousQuotes
 * Tracks selected home designs for quoting across pages using localStorage.
 *
 * Expected markup:
 * - "Add to quote" triggers: .js-add-to-quote[data-hd-id][data-hd-name]
 * - Optional "Remove from quote" triggers: .js-remove-from-quote[data-hd-id]
 * - Optional "View quote" links: .js-go-to-quote[data-hd-id]
 * - Optional counters: .js-quote-count
 *
 * Data model:
 * - Stored in localStorage as JSON array of unique IDs (strings): ["728","885",...]
 * - Labels are resolved from DOM or via GF (ids -> titles), so storage stays lean.
 */
window.nousQuotes = (function () {
  var storageKey = '_nous_hallmark_quote_designs';

  function getList() {
    try {
      var raw = window.localStorage.getItem(storageKey);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (e) {
      console.error('Quote list parse error:', e);
      return [];
    }
  }

  function saveList(list) {
    try {
      var unique = [];
      list.forEach(function (id) {
        id = String(id).trim();
        if (id && unique.indexOf(id) === -1) {
          unique.push(id);
        }
      });
      window.localStorage.setItem(storageKey, JSON.stringify(unique));
      return unique;
    } catch (e) {
      console.error('Quote list save error:', e);
      return list;
    }
  }

  function isInList(id) {
    id = String(id || '').trim();
    if (!id) return false;
    var list = getList();
    return list.indexOf(id) !== -1;
  }

  function add(id) {
    id = String(id || '').trim();
    if (!id) {
      console.error('Missing hd-id for quote add');
      return;
    }
    var list = getList();
    if (list.indexOf(id) === -1) {
      list.push(id);
      list = saveList(list);
    }
    updateUI(list);
  }

  function remove(id) {
    id = String(id || '').trim();
    if (!id) return;
    var list = getList().filter(function (val) {
      return String(val) !== id;
    });
    list = saveList(list);
    updateUI(list);
  }

  function clear() {
    try {
      window.localStorage.removeItem(storageKey);
    } catch (e) {
      console.error('Quote list clear error:', e);
    }
    updateUI([]);
  }

  function updateUI(list) {
    if (!Array.isArray(list)) {
      list = getList();
    }
    var set = list.map(String);

    // Per-card buttons
    document.querySelectorAll('.js-add-to-quote').forEach(function (btn) {
      var pid = String(btn.getAttribute('data-hd-id') || '').trim();
      if (!pid) return;

      var container =
        btn.closest('.js-card-search-home-designs, .js-feature-home-details, .js-flexi-home-intro-block, .js-flexi-favourite-designs-block') ||
        btn.parentElement ||
        btn.parentNode;

      var viewLink = container ? container.querySelector('.js-go-to-quote') : null;
      var removeBtn = container ? container.querySelector('.js-remove-from-quote[data-hd-id="' + pid + '"]') : null;

      var inQuote = set.indexOf(pid) !== -1;

      // Style hook on the add button
      btn.classList.toggle('is-in-quote', inQuote);

      // Update button label if a label span is present
      var labelEl = btn.querySelector('.btn-label');
      if (labelEl) {
        labelEl.textContent = inQuote ? 'Added to Quote' : 'Add this home to Quote';
      }

      // Optionally swap icon state if an icon element exists
      var iconEl = btn.querySelector('.icon');
      if (iconEl) {
        iconEl.classList.toggle('icon-plus', !inQuote);
        iconEl.classList.toggle('icon-arrow-right', inQuote);
      }

      if (viewLink) {
        viewLink.classList.toggle('d-none', !inQuote);
      }
      if (removeBtn) {
        removeBtn.classList.toggle('d-none', !inQuote);
      }
    });

    // Global quote count badges (header only)
    var count = set.length;

    // Update only js-quote-count-wrapper instances
    document.querySelectorAll('.js-quote-count-wrapper').forEach(function (wrapper) {
      if (count > 0) {
        wrapper.classList.remove('d-none');
        wrapper.classList.add('d-flex');
      } else {
        wrapper.classList.add('d-none');
        wrapper.classList.remove('d-flex');
      }

      var span = wrapper.querySelector('.js-quote-count');
      if (span) {
        span.textContent = count > 0 ? count : '';
      }
    });
  }

  // Bind "Add to Quote" buttons
  function bindAddButtons() {
    document.querySelectorAll('.js-add-to-quote').forEach(function (btn) {
      if (btn.dataset.nousQuoteBound === '1') return;
      btn.dataset.nousQuoteBound = '1';

      btn.addEventListener('click', function () {
        var pid = btn.getAttribute('data-hd-id') || '';
        if (!pid) {
          console.error('js-add-to-quote missing data-hd-id');
          return;
        }

        var wasInList = isInList(pid);

        // Persist to localStorage
        add(pid);

        var href = btn.getAttribute('href');
        if (!href) {
          return;
        }

        try {
          var url = new URL(href, window.location.origin);

          // Normalise: drop any legacy params we don't use
          url.searchParams.delete('hd_id');
          url.searchParams.delete('hd-select');

          if (wasInList) {
            // Already tracked in localStorage: no need to send hd in URL
            url.searchParams.delete('hd');
          } else {
            // First time: ensure hd param so form can prefill from link
            url.searchParams.set('hd', pid);
          }

          btn.setAttribute('href', url.pathname + url.search);
        } catch (e) {
          console.error('Quote link URL parse error:', e);
        }
      });
    });
  }

  // Bind "Remove from Quote" buttons
  function bindRemoveButtons() {
    document.querySelectorAll('.js-remove-from-quote').forEach(function (btn) {
      if (btn.dataset.nousQuoteBound === '1') return;
      btn.dataset.nousQuoteBound = '1';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var pid = btn.getAttribute('data-hd-id') || '';
        if (!pid) {
          console.error('js-remove-from-quote missing data-hd-id');
          return;
        }
        remove(pid);
      });
    });
  }

  function init() {
    bindAddButtons();
    bindRemoveButtons();
    updateUI(getList());
  }

  return {
    init: init,
    add: add,
    remove: remove,
    clear: clear,
    getList: getList,
    isInList: isInList,
    sync: function () { updateUI(getList()); }
  };
})();

// Clear stored quote designs when the quote form (ID 9) submits successfully.
jQuery(function($) {
  // Clear stored quote designs when the quote form (ID 9) submits successfully.
  $(document).on('gform_confirmation_loaded', function(event, formId) {
    if (formId === 9) {
      if (window.nousQuotes && typeof window.nousQuotes.clear === 'function') {
        window.nousQuotes.clear();
      } else {
        try {
          window.localStorage.removeItem('_nous_hallmark_quote_designs');
        } catch (e) {
          console.warn('Could not clear stored quote designs after submission:', e);
        }
      }
    }
  });
});


////////////////////////////////////////////////////////////////////////////////////
// Home design family switching
////////////////////////////////////////////////////////////////////////////////////
/**
 * Home design family / variant switching.
 *
 * Handles clicking the range pills on cards and updates:
 * - price
 * - features (beds / baths / cars / living)
 * - house properties (floor area / width / length)
 * - frontage text
 * - explore link
 * - favourites target
 */
(function () {
  /**
   * Facade requests already made on this page, keyed by variant ID, so
   * switching back to a variant reuses the first response.
   * @since 1.0.0
   * @type {Object<string, Promise<Object>>}
   */
  var facadeRequests = {};

  /**
   * Fetch the facade carousel cells for a variant, once per page view.
   * @since 1.0.0
   * @param {number} variantId
   * @returns {Promise<Object>} Resolves to { html, count }.
   */
  function fetchVariantFacades(variantId) {
    var key = String(variantId);

    if (!facadeRequests[key]) {
      var ajaxUrl = window.ajaxurl || (window.location.origin + '/wp-admin/admin-ajax.php');
      var params = new URLSearchParams({
        action: 'hh_get_variant_facades',
        pid: key
      });

      facadeRequests[key] = fetch(ajaxUrl + '?' + params.toString(), {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (!data || !data.success || !data.data) {
            throw new Error('Unexpected facades response');
          }
          return data.data;
        })
        .catch(function (err) {
          // Forget the failure so the next click can retry.
          delete facadeRequests[key];
          throw err;
        });
    }

    return facadeRequests[key];
  }

  /**
   * Record the facades the server rendered into a card as that variant's
   * response, so switching back to it reuses them instead of fetching them.
   * Flickity may already have positioned the cells, so the copies drop the
   * inline position and state it adds.
   * @since 1.1.2
   * @param {HTMLElement} cardEl
   * @param {number} variantId - The variant whose facades the server rendered.
   * @returns {void}
   */
  function seedFacadesFromCard(cardEl, variantId) {
    var key = String(variantId);
    var carousel = cardEl.querySelector('.js-home-design-carousel');
    if (!carousel || facadeRequests[key]) return;

    var cells = carousel.querySelectorAll('.carousel-cell');
    if (!cells.length) return;

    var html = '';
    cells.forEach(function (cell) {
      var copy = cell.cloneNode(true);
      copy.removeAttribute('style');
      copy.removeAttribute('aria-hidden');
      copy.classList.remove('is-selected');
      html += copy.outerHTML;
    });

    facadeRequests[key] = Promise.resolve({ html: html, count: cells.length });
  }

  /**
   * Safely parse JSON from a data attribute.
   * @param {string} json
   * @returns {Array|null}
   */
  function parseVariants(json) {
    if (!json) return null;
    try {
      var data = JSON.parse(json);
      return Array.isArray(data) ? data : null;
    } catch (e) {
      console.warn('home-design-variants: failed to parse variants JSON', e);
      return null;
    }
  }

  /**
   * Format a numeric price into "$xxx,xxx".
   * We approximate PHP's nous_format_price here.
   * @param {string|number} rawPrice
   * @returns {string}
   */
  function formatPrice(rawPrice) {
    if (rawPrice === null || rawPrice === undefined || rawPrice === '') {
      return '';
    }

    var num = typeof rawPrice === 'number'
      ? rawPrice
      : parseFloat(String(rawPrice).replace(/[^0-9.]/g, ''));

    if (isNaN(num)) {
      return '';
    }

    // AU-style formatting, no decimals
    return '$' + num.toLocaleString('en-AU', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  /**
   * Build frontage text like "10m" or "Acreage" from lot_width.
   * Mirrors hallmark_format_lot_width() in site/inc/nous-site.php.
   * @param {string} lotWidth
   * @returns {string}
   */
  function buildFrontageLabel(lotWidth) {
    var value = String(lotWidth || '').trim();
    if (!value) return '';

    if (value === '30-over') {
      return 'Acreage';
    }

    // Strip a trailing 'm' if present, then add 'm' back for consistency
    var cleaned = value.replace(/m$/i, '');
    if (!cleaned) return '';
    return cleaned + 'm';
  }

  /**
   * Find a variant by ID from the variants array.
   * @param {Array} variants
   * @param {number} id
   * @returns {Object|null}
   */
  function findVariantById(variants, id) {
    if (!Array.isArray(variants)) return null;
    for (var i = 0; i < variants.length; i++) {
      if (parseInt(variants[i].id, 10) === id) {
        return variants[i];
      }
    }
    return null;
  }

  /**
   * Update the DOM inside a single card for the given variant.
   * @param {HTMLElement} cardEl
   * @param {Object} variant
   */
  function updateCardForVariant(cardEl, variant) {
    if (!cardEl || !variant) return;

    var variantId = parseInt(variant.id, 10);
    if (!variantId) return;

    // Update card-level state
    cardEl.dataset.activeVariantId = String(variantId);

    // 1. Update active pill state
    var pills = cardEl.querySelectorAll('.js-variant-pill');
    pills.forEach(function (pill) {
      var pillId = parseInt(pill.getAttribute('data-variant-id'), 10);
      if (pillId === variantId) {
        pill.classList.add('is-active');
      } else {
        pill.classList.remove('is-active');
      }
    });

    // 2. Update price
    var priceEl = cardEl.querySelector('.js-starting-price');
    if (priceEl && variant.price !== undefined && variant.price !== null) {
      var formatted = formatPrice(variant.price);
      if (formatted) {
        priceEl.textContent = formatted + '*';
      }
    }

    // 3. Update features: beds / baths / cars / living
    var featureEls = cardEl.querySelectorAll('.js-property-number');
    featureEls.forEach(function (el, index) {
      var featureKey = el.getAttribute('data-feature');

      // Fallback if no data-feature exists
      if (!featureKey) {
        if (index === 0) featureKey = 'beds';
        else if (index === 1) featureKey = 'baths';
        else if (index === 2) featureKey = 'cars';
        else if (index === 3) featureKey = 'living';
      }

      if (!featureKey) return;
      if (variant[featureKey] === undefined || variant[featureKey] === null) return;

      el.textContent = String(variant[featureKey]);
    });

    // 4. Update house properties: floor_area / house_width / house_length
    var propertyEls = cardEl.querySelectorAll('.js-house-property');
    propertyEls.forEach(function (el, index) {
      var propKey = el.getAttribute('data-property');

      // Backwards-compat: if no data-property is set, fall back to the
      // original ordering used in the PHP card template:
      //  0 => floor_area
      //  1 => house_width
      //  2 => house_length
      if (!propKey) {
        if (index === 0) {
          propKey = 'floor_area';
        } else if (index === 1) {
          propKey = 'house_width';
        } else if (index === 2) {
          propKey = 'house_length';
        }
      }

      if (!propKey) return;
      if (variant[propKey] === undefined || variant[propKey] === null) return;

      var value = String(variant[propKey]);

      // Add units to match PHP:
      if (propKey === 'floor_area') {
        value = value + 'm2';
      } else if (propKey === 'house_width' || propKey === 'house_length') {
        value = value + 'm';
      }

      el.textContent = value;
    });

    // 5. Update frontage subheading
    var subheadingEl = cardEl.querySelector('.js-card-subheading');
    if (subheadingEl && variant.lot_width !== undefined && variant.lot_width !== null) {
      var frontageLabel = buildFrontageLabel(String(variant.lot_width));
      if (frontageLabel) {
        subheadingEl.textContent = 'Minimum frontage ' + frontageLabel + '*';
      }
    }

    // 6. Update explore link
    var linkEl = cardEl.querySelector('.js-card-explore-link');
    if (linkEl && variant.permalink) {
      linkEl.setAttribute('href', variant.permalink);
    }

    // 7. Update favourites target
    var favBtn = cardEl.querySelector('.js-add-to-favourites');
    if (favBtn) {
      favBtn.setAttribute('data-hd-pid', String(variantId));

      // Re-sync favourites UI for this card when the active variant changes
      if (window.nousFavourites && typeof window.nousFavourites.syncCard === 'function') {
        window.nousFavourites.syncCard(cardEl);
      }
    }

    // 8. Update facades carousel via AJAX, unless the card already shows
    //    this variant's facades (the server renders them on page load).
    //    facadesWantedId is the variant last clicked; facadesShownId is the
    //    variant whose facades are in the carousel now.
    var carousel = cardEl.querySelector('.js-home-design-carousel');
    var wantedId = String(variantId);
    cardEl.dataset.facadesWantedId = wantedId;

    if (carousel && variantId && cardEl.dataset.facadesShownId === wantedId) {
      // Back to the facades already showing: drop any pending request.
      cardEl.classList.remove('is-loading-facades');
    } else if (carousel && variantId) {
      // Optional: add a loading state class to the card while we update
      cardEl.classList.add('is-loading-facades');

      fetchVariantFacades(variantId)
        .then(function (payload) {
          // Superseded by a later click, or already rendered by an earlier
          // click sharing the same request.
          if (cardEl.dataset.facadesWantedId !== wantedId ||
              cardEl.dataset.facadesShownId === wantedId) {
            return;
          }

          var html = payload.html || '';
          var count = payload.count || 0;

          // Replace existing carousel cells
          // Assumes markup: <div class="flickity-carousel js-home-design-carousel"> ...cells..., .carousel-info ... </div>

          // 1. Destroy existing Flickity instance if present (jQuery initialised)
          if (window.jQuery) {
            var $ = window.jQuery;
            var $carousel = $(carousel);
            var flkty = $carousel.data('flickity');
            if (flkty) {
              flkty.destroy();
            }
          }

          // 2. Remove old cells and insert new
          //    Keep the .carousel-info block as-is.
          var cells = carousel.querySelectorAll('.carousel-cell');
          cells.forEach(function (cell) {
            cell.parentNode.removeChild(cell);
          });

          // Inject new cells just before .carousel-info
          var infoEl = carousel.querySelector('.carousel-info');
          var temp = document.createElement('div');
          temp.innerHTML = html;

          var newCells = Array.prototype.slice.call(temp.children);
          newCells.forEach(function (cell) {
            if (infoEl && infoEl.parentNode === carousel) {
              carousel.insertBefore(cell, infoEl);
            } else {
              carousel.appendChild(cell);
            }
          });

          // 3. Update total count
          var totalEl = carousel.querySelector('.carousel-info .total');
          if (totalEl) {
            totalEl.textContent = '/ ' + String(count);
          }

          // 4. Re-init Flickity with the same options as init_home_design_carousels()
          if (window.jQuery && typeof jQuery.fn.flickity === 'function') {
            var $ = window.jQuery;
            var $carousel = $(carousel);

            $carousel.flickity({
              cellSelector: '.carousel-cell',
              cellAlign: 'center',
              contain: true,
              wrapAround: true,
              pageDots: false,
              prevNextButtons: true,
              imagesLoaded: true,
              arrowShape: 'm25.21,44.06h66.35c3.28,0,5.94,2.66,5.94,5.94s-2.66,5.94,5.94,5.94H25.21l29.02,29.02c2.33,2.33,2.31,6.11-.04,8.42-2.32,2.28-6.05,2.26-8.35-.04L2.5,50,45.84,6.66c2.3-2.3,6.03-2.32,8.35-.04,2.35,2.31,2.37,6.09.04,8.42l-29.02,29.02Z'
            });

            // Re-wire the slide counter for this carousel only. destroy()
            // leaves jQuery handlers bound, so drop the previous one first.
            $carousel.off('change.flickity');
            $carousel.on('change.flickity', function (event, index) {
              var currentSlide = index + 1;
              $carousel.find('.js-current-slide').text(currentSlide);
            });

            // Reset slide counter to 1 explicitly
            var currentSlideEl = carousel.querySelector('.carousel-info .js-current-slide');
            if (currentSlideEl) {
              currentSlideEl.textContent = '1';
            }
          }

          cardEl.dataset.facadesShownId = wantedId;
        })
        .catch(function (err) {
          if (window.DEBUG_MODE) {
            console.error('Failed to load facades for variant', variantId, err);
          }
        })
        .finally(function () {
          // A superseded request leaves the loading state to the current one.
          if (cardEl.dataset.facadesWantedId === wantedId) {
            cardEl.classList.remove('is-loading-facades');
          }
        });
    }
  }

  /**
   * Initialise a single home-design card.
   * @param {HTMLElement} cardEl
   */
  function initCard(cardEl) {
    if (!cardEl) return;

    // initAllCards() runs again after every filter and load more, so skip
    // cards already wired up rather than doubling their click handlers.
    if (cardEl.dataset.variantsInit === '1') return;

    var variantsJson = cardEl.getAttribute('data-variants');
    if (!variantsJson) return;

    var variants = parseVariants(variantsJson);
    if (!variants || !variants.length) return;

    cardEl.dataset.variantsInit = '1';

    // Initial sync: use data-active-variant-id, or fall back to first
    var activeId = parseInt(cardEl.getAttribute('data-active-variant-id'), 10);

    // The server renders the facades for data-active-variant-id, so they
    // also stand in for that variant's request.
    if (activeId) {
      cardEl.dataset.facadesShownId = String(activeId);
      seedFacadesFromCard(cardEl, activeId);
    }
    var activeVariant = activeId ? findVariantById(variants, activeId) : null;
    if (!activeVariant) {
      activeVariant = variants[0];
      cardEl.dataset.activeVariantId = String(activeVariant.id);
    }

    // Wire up pill clicks
    var pills = cardEl.querySelectorAll('.js-variant-pill');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function (event) {
        event.preventDefault();
        var targetId = parseInt(pill.getAttribute('data-variant-id'), 10);
        if (!targetId) return;

        var selected = findVariantById(variants, targetId);
        if (!selected) return;

        updateCardForVariant(cardEl, selected);
      });
    });

    // Optional: ensure initial variant state is fully synced to DOM
    updateCardForVariant(cardEl, activeVariant);
  }

  /**
   * Initialise all cards on the page.
   */
  function initAllCards() {
    var cards = document.querySelectorAll('.js-card-search-home-designs[data-variants]');
    cards.forEach(initCard);
  }

  // Expose a public API so Ajax blocks can re-init variants
  window.homeDesignFamily = {
    initCard: initCard,
    initAllCards: initAllCards
  };

  // DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCards);
  } else {
    initAllCards();
  }
})();


////////////////////////////////////////////////////////////////////////////////////
// Backwards compatibility shims
////////////////////////////////////////////////////////////////////////////////////
function flexi_favourite_designs_block() {
  if (window.nousFavourites) {
    window.nousFavourites.bindFavouritesBlock();
    window.nousFavourites.syncFromCookie();
  }
}



////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: House and Land Filter Grid
////////////////////////////////////////////////////////////////////////////////////
function flexi_home_designs_filter_grid() {
  DEBUG_MODE = false; // Set to true to enable detailed logging

  var flexi_home_designs_filter_grid = document.querySelectorAll('.section-flexi-home-designs-filter-grid');
  flexi_home_designs_filter_grid.forEach(function(block) {
    var filterBlock = block.querySelector('.js-filter-block');
    var filterForm = filterBlock ? filterBlock.querySelector('.js-filter-form') : null;

    // ---------------------
    // BUDGET FIELDS
    // ---------------------
    var filterBudgetSelect = filterForm ? filterForm.querySelector('.js-range-slider-min, .js-range-slider-max') : null;
    var filterBudgetRangeMin = filterForm.querySelector('.js-range-slider-min');
    var filterBudgetRangeMax = filterForm.querySelector('.js-range-slider-max');


    var postsGrid = block.querySelector('.js-posts-cards');
    var noResultsRangeBlock = block.querySelector('.no-results-range-message');

    var filterBlockTrigger = block.querySelectorAll('.js-filter-sticky-scroll-trigger');
    var resetFilterBtn = block.querySelectorAll('.js-reset-filters');
    var applyFilterBtn = block.querySelectorAll('.js-filters');
    var loadMorePostsBtn = block.querySelector('.js-load-posts');

    var filterBlockLive = false;
    var rangeFilterBtns = document.querySelectorAll('input[name="hh-range"]');

    // Helper: run Ajax filter, resetting to a given page (defaults to 1)
    function runFilter(targetPage) {
      if (!loadMorePostsBtn) return;

      var page = parseInt(targetPage, 10) || 1;

      // Keep button and hidden field in sync
      loadMorePostsBtn.dataset.paged = page;
      if (filterForm) {
        var pagedField = filterForm.querySelector('input[name="paged"]');
        if (pagedField) {
          pagedField.value = page;
        }
      }

      // Run Ajax filter and scroll up to the results
      filterPosts(page, loadMorePostsBtn, 'filter');
      //scrollToFilterBlock();
    }

    ////////////////////////////////////////////////////////////////////////////////////
    // Initialize Home Design Carousels
    ////////////////////////////////////////////////////////////////////////////////////
    init_home_design_carousels();

    // Minus buttons event handlers
    block.querySelectorAll('.js-filter-qty-select .js-minus').forEach(function(minusBtn) {
      minusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var qtySelectWrapper = this.closest('.js-filter-qty-select');
        var currentSelection = qtySelectWrapper.querySelector('input').value.toLowerCase().replace(/[^a-z0-9]/g, '');
        var filterOption = qtySelectWrapper.closest('.js-filter-option');
        var filterSelect = filterOption.querySelector('select');

        var options = filterSelect.querySelectorAll('option');
        for (var i = 0; i < options.length; i++) {
          var optionValue = options[i].value.toLowerCase().replace(/[^a-z0-9]/g, '');

          if (optionValue === currentSelection) {
            var previousOption = options[i - 1];

            if (previousOption) {
              var inputElement = qtySelectWrapper.querySelector('input');
              var cleanText = previousOption.textContent.trim();

              inputElement.value = cleanText;
              filterSelect.value = previousOption.value;

              // Trigger change event
              var changeEvent = new Event('change', { bubbles: true });
              filterSelect.dispatchEvent(changeEvent);
              break; // Exit the loop once the match is found
            }
          }
        }
      });
    });

    // Plus buttons event handlers
    block.querySelectorAll('.js-filter-qty-select .js-plus').forEach(function(plusBtn) {
      plusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var qtySelectWrapper = this.closest('.js-filter-qty-select');
        var currentSelection = qtySelectWrapper.querySelector('input').value.toLowerCase().replace(/[^a-z0-9]/g, '');
        var filterOption = qtySelectWrapper.closest('.js-filter-option');
        var filterSelect = filterOption.querySelector('select');

        var options = filterSelect.querySelectorAll('option');
        for (var i = 0; i < options.length; i++) {
          var optionValue = options[i].value.toLowerCase().replace(/[^a-z0-9]/g, '');

          if (optionValue === currentSelection) {
            var nextOption = options[i + 1];

            if (nextOption) {
              var inputElement = qtySelectWrapper.querySelector('input');
              var cleanText = nextOption.textContent.trim();

              inputElement.value = cleanText;
              filterSelect.value = nextOption.value;

              // Trigger change event
              var changeEvent = new Event('change', { bubbles: true });
              filterSelect.dispatchEvent(changeEvent);
              break; // Exit the loop once the match is found
            }
          }
        }
      });
    });

    
    ////////////////////////////////////////////////////////////
    // BUDGET FILTER CHANGE: ON CHANGE EVENT
    ////////////////////////////////////////////////////////////
    if (filterBudgetSelect) {

      let lastMin, lastMax;

      // runs filterPosts only after the slider stops changing
      const debounce = (fn, wait = 400) => {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn(...args), wait);
        };
      };

      const runFilterDebounced = debounce((source) => {
        if (source === 'rail') { // Run only on rail click
          filterPosts(1, loadMorePostsBtn, 'filter');
        }
      }, 600);

      
      document.querySelectorAll('.js-range-slider').forEach(function (wrap) {
        wrap.addEventListener('range-slider:change', function (e) {
          const { min, max, source } = e.detail;
          //console.log('Slider changed:', min, max, source);
          runFilterDebounced(source);
        });
      });

    }
    //--------------------------------------

    
    

    // Chosen reports a selection with a jQuery-triggered change, which never
    // reaches the native form listener further down. Only those synthetic
    // events are handled here. A native change (a phone, where Chosen leaves
    // the select alone) has an originalEvent and is left to the form listener,
    // so one change sends one request.
    if (filterForm && loadMorePostsBtn && window.jQuery) {
      jQuery(filterForm).on('change', 'select[name="lot-width"], select[name="budget"]', function (e) {
        if (e.originalEvent) return;
        runFilter(1);
      });
    }

    // The sort select sits outside the filter form. A jQuery handler receives
    // both the native change and the one Chosen triggers, exactly once each.
    var sortSelect = block.querySelector('select.js-hd-filter-sort');
    if (sortSelect && loadMorePostsBtn && window.jQuery) {
      jQuery(sortSelect).on('change', function () {
        runFilter(1);
      });
    }

    if (filterBlockTrigger) {
      filterBlockTrigger.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();

          document.querySelector('body').classList.toggle('no-scroll');
          filterBlock.classList.toggle('active');
        });
      });
    }

    // Reset filter button event handler
    if (resetFilterBtn) {
      resetFilterBtn.forEach(function (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();

          // Reset the form first
          if (filterForm) {
            filterForm.reset();


            // Reset ALL range sliders
            filterForm.querySelectorAll('.js-range-slider').forEach(function (wrap) {
              const min = parseFloat(wrap.dataset.min);
              const max = parseFloat(wrap.dataset.max);

              const minRange = wrap.querySelector('.js-range-slider-min');
              const maxRange = wrap.querySelector('.js-range-slider-max');

              if (!minRange || !maxRange) return;

              minRange.value = min;
              maxRange.value = max;

              minRange.dispatchEvent(new Event('input', { bubbles: true }));
              maxRange.dispatchEvent(new Event('input', { bubbles: true }));
            });


            // Clear the "Search by Home name" field explicitly
            var homeNameInput = filterForm.querySelector('input#home-name');
            if (homeNameInput) {
              homeNameInput.value = '';
            }

            // Reset the +/- quantity selects
            var selectFields = filterForm.querySelectorAll('.js-filter-option');
            selectFields.forEach(function (select) {
              var selection = select.querySelector('select');
              var selectionInput = select.querySelector('.js-filter-qty-select');

              if (!selection) return;

              selection.querySelectorAll('option').forEach(function (option) {
                option.removeAttribute('selected');
              });

              selection.selectedIndex = 0;
              jQuery(selection).trigger('chosen:updated'); //update chosen
              jQuery(selection).trigger('change'); //trigger change to update formatting

              if (selection.options[0] && selectionInput) {
                var firstOptionText = selection.options[0].textContent.trim();
                var inputElement = selectionInput.querySelector('input');

                selection.options[0].setAttribute('selected', 'selected');

                if (inputElement) {
                  inputElement.value = firstOptionText;
                }
              }
            });

            // Explicitly clear the hh-range radios so no range is selected
            var rangeRadios = filterForm.querySelectorAll('input[name="hh-range"]');
            rangeRadios.forEach(function (radio) {
              radio.checked = false;
            });

            // Explicitly reset Lot Width select
            var lotWidthSelect = filterForm.querySelector('#lot-width');
            if (lotWidthSelect) {
              lotWidthSelect.selectedIndex = 0;
            }

            // Explicitly reset Budget select + hidden price-from / price-to fields
            var budgetSelect = filterForm.querySelector('#budget');
            if (budgetSelect) {
              budgetSelect.selectedIndex = 0;

              var firstBudgetOpt  = budgetSelect.options[0] || null;
              var priceFromInput  = filterForm.querySelector('.js-price-from');
              var priceToInput    = filterForm.querySelector('.js-price-to');

              if (priceFromInput && priceToInput) {
                if (firstBudgetOpt) {
                  priceFromInput.value = firstBudgetOpt.value || '';
                  priceToInput.value   = firstBudgetOpt.getAttribute('data-max') || '';
                } else {
                  priceFromInput.value = '';
                  priceToInput.value   = '';
                }
              }
            }

            // Clear Filter Sort Dropdown
            const select = block.querySelector('.js-hd-filter-sort');
            if (select) {
              select.value = 'default';
              jQuery(select).trigger('chosen:updated'); //refresh chosen
            }


            // Explicitly reset Sort By select
            var sortSelect = filterForm.querySelector('#sort-by');
            if (sortSelect) {
              sortSelect.selectedIndex = 0;
            }

            // If Chosen is enhancing these selects, refresh its UI
            if (window.jQuery && jQuery.fn.chosen) {
              jQuery(filterForm).find('#lot-width, #budget, #sort-by').trigger('chosen:updated');
            }
          }

          // Clearing filters that are already clear changes no results, so
          // it sends no request and adds no history entry.
          if (filterForm && loadMorePostsBtn && isShowingQuery(buildFilterQuery(1))) {
            return;
          }

          // Reset paging and trigger a fresh Ajax load of unfiltered results.
          // filterPosts() adds the one history entry for them, and must run
          // even when the last filter was this same query.
          if (filterForm && loadMorePostsBtn) {
            lastFilterQuery = null;
            loadMorePostsBtn.dataset.paged = 1;
            var pagedField = filterForm.querySelector('input[name="paged"]');
            if (pagedField) {
              pagedField.value = 1;
            }

            // Use the helper so scroll + Ajax stay consistent
            if (typeof runFilter === 'function') {
              runFilter(1);
            } else if (typeof filterPosts === 'function') {
              filterPosts(1, loadMorePostsBtn, 'filter');
              scrollToFilterBlock();
            } else {
              scrollToFilterBlock();
            }
          } else {
            // Fallback scroll if we had no button/form
            scrollToFilterBlock();
          }
        });
      });
    } // ENDIF

    // "Click here to see" — clear range filter and re-run search across all ranges
    var clearRangeLink = block.querySelector('.js-clear-range-filter');
    if (clearRangeLink) {
      clearRangeLink.addEventListener('click', function(e) {
        e.preventDefault();
        // Uncheck all range radios
        var rangeRadios = filterForm.querySelectorAll('input[name="hh-range"]');
        rangeRadios.forEach(function(radio) {
          radio.checked = false;
        });
        // Re-filter from page 1
        runFilter(1);
      });
    }

    // Apply filter button event handler
    if (applyFilterBtn && loadMorePostsBtn) {
      applyFilterBtn.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          // When the user actively filters, start from page 1
          runFilter(1);
          scrollToFilterBlock();

          // Close the filter block on Mobile only (<= 992px)
          if (window.matchMedia('(max-width: 992px)').matches) {
            const filterBlock = trigger.closest('.filter-block');
            if (filterBlock) {
              document.querySelector('body').classList.toggle('no-scroll');
              filterBlock.classList.remove('active'); // or whatever closes it
            }
          }

        });
      });
    } // ENDIF

    // Pressing Enter in the "Search by Home name" field should trigger filtering
    if (filterForm) {
      var homeNameInput = filterForm.querySelector('#home-name');
      if (homeNameInput) {
        homeNameInput.addEventListener('keydown', function(e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            runFilter(1);
          }
        });
      }
    }

    // if (filterBlockLive) {
    //   rangeFilterBtns.forEach(btn => {
    //     btn.addEventListener('change', (e) => {
    //       console.log('Selected value:', e.target.value);
    //       var currentPage = parseInt(loadMorePostsBtn.dataset.paged) || 1;
    //       filterPosts(currentPage, loadMorePostsBtn, 'filter');
    //       scrollToFilterBlock();
    //     });
    //   });
    // }

    // Live updates: whenever a filter control changes, re-run the filter
    if (filterForm && loadMorePostsBtn) {
      filterForm.addEventListener('change', function(e) {
        var target = e.target;

        // Ignore changes on the hidden paged field; we manage that ourselves
        if (target && target.name === 'paged') {
          return;
        }

        // Any other change to a form control triggers a fresh filter from page 1
        runFilter(1);
      });
    }

    // Load more posts button event handler
    if (loadMorePostsBtn) {
      loadMorePostsBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var currentPage = parseInt(loadMorePostsBtn.dataset.paged) || 1;
        var nextPage = currentPage + 1;

        if (DEBUG_MODE) {
          console.log('Load More Posts Clicked');
          console.log('Current Page:', currentPage);
          console.log('Next Page:', nextPage);
        } // ENDIF

        filterPosts(nextPage, loadMorePostsBtn, 'pagination');

      });
    } // ENDIF

    function scrollToFilterBlock(forceScroll) {
      // Prefer to scroll to the results grid; fall back to the filter block
      var targetEl = postsGrid || filterBlock;
      if (!targetEl) return;

      var header = document.querySelector('header');
      var headerOuterHeight = header ? header.offsetHeight : 0;

      // Use bounding rect + current scroll so it works with sticky headers
      var rect = targetEl.getBoundingClientRect();
      var absoluteTop = rect.top + window.pageYOffset;

      var targetTop = absoluteTop - headerOuterHeight - 40; // small gap above
      if (targetTop < 0) {
        targetTop = 0;
      }

      // If we're already close, don't scroll again (prevents jiggle on live updates)
      if (!forceScroll && Math.abs(window.pageYOffset - targetTop) < 30) {
        return;
      }

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    } // ENDFUNC
    

    // Query string of the last filter request, so a repeat of the same filter
    // (Enter in the home name field, then the blur that follows) is not sent
    // twice. Cleared whenever pagination appends, because a filter then has
    // to replace the appended pages.
    var lastFilterQuery = null;

    // The query string the grid currently shows results for. popstate also
    // fires when only the #fragment changes, and that must not refilter.
    var shownSearch = window.location.search;

    // Counts filter requests, so a slow response that a newer filter has
    // replaced (two quick Back presses, say) is dropped rather than drawn over
    // it. Load more never replaces a filter, but is dropped once a later
    // filter starts.
    var filterGeneration = 0;

    /**
     * Adds a history entry for a new results URL and records it as shown.
     *
     * @since 1.1.2
     * @param {string} url - The URL to push.
     * @returns {void}
     */
    function pushResultsUrl(url) {
      history.pushState(null, '', url);
      shownSearch = window.location.search;
    }

    /**
     * Serialises the filter form into the query string a filter request and
     * the results URL use, leaving out empty values.
     *
     * @since 1.1.3
     * @param {number} page - Last page to return.
     * @returns {string} Query string without the leading "?".
     */
    function buildFilterQuery(page) {
      const formData = new FormData(filterForm); // Serialise form data
      formData.set('paged', page); // Set the current page number in the form

      // Ensure sort-by reflects the current select value (Chosen-safe)
      // const sortSelect = filterForm.querySelector('select[name="sort-by"]');
      const blockSortSelect = block.querySelector('select.js-hd-filter-sort');
      if (blockSortSelect) {
        formData.set('sort-by', blockSortSelect.value || 'default');
      }

      // Ensure price-from / price-to are in sync with the selected budget
      // const budgetVal = formData.get('budget');
      const budgetVal = formData.get('price-from');
      if (
        budgetVal &&
        budgetVal !== 'any' &&
        budgetVal !== 'all'
      ) {
        
        
        let priceFrom = formData.get('price-from');
        let priceTo   = formData.get('price-to');
        if (priceFrom !== null && priceFrom !== '') {
          formData.set('budget', formData.get('price-from')); //add budget to form data
        }

        // If they're missing or still "0", derive them from the <option>
        if (!priceFrom || priceFrom === '0' || !priceTo || priceTo === '0') {
          if (filterBudgetSelect) {
            const matchingOpt = filterBudgetSelect.querySelector(
              'option[value="' + budgetVal + '"]'
            );
            if (matchingOpt) {
              const max = matchingOpt.getAttribute('data-max') || '';
              formData.set('price-from', budgetVal);
              formData.set('price-to', max);
            }
          }
        }
      }

      // Create a new FormData object with only non-empty values
      const filteredFormData = new FormData();
      for (let [key, value] of formData.entries()) {
        if (value !== '' && value !== null && value !== undefined) {
          filteredFormData.append(key, value);
        }
      } // ENDFOR

      return new URLSearchParams(filteredFormData).toString();
    }

    /**
     * Whether the grid shows, or is loading, the results for a query string.
     * A page opened with no query string shows every design, the same results
     * as the cleared filters.
     *
     * @since 1.1.3
     * @param {string} query - Query string from buildFilterQuery().
     * @returns {boolean}
     */
    function isShowingQuery(query) {
      if (lastFilterQuery !== null) {
        return lastFilterQuery === query;
      }

      var search = window.location.search.replace(/^\?/, '');
      return search === '' || search === query;
    }

    /**
     * Fetches home design cards from the filter grid AJAX handler.
     *
     * @since 1.0.0
     * @param {number} page - Last page to return.
     * @param {HTMLElement} pagination_btn - The Load more button.
     * @param {string} filter_type - 'filter' replaces the grid, 'pagination' appends.
     * @param {number} [fromPage] - First page to return. Defaults to page, so a
     *   restore of ?paged=N can ask for pages 2..N in a single request.
     * @param {string} [historyMode] - 'push' (default) adds a history entry for
     *   the results, 'replace' rewrites the current one, and 'history' also
     *   rewrites it, for results redrawn on Back or Forward, which are not a
     *   new filter action.
     * @returns {void}
     */
    function filterPosts(page = 1, pagination_btn, filter_type, fromPage, historyMode = 'push') {
      DEBUG_MODE = false;
      const queryString = buildFilterQuery(page);

      if (filter_type === 'filter') {
        if (queryString === lastFilterQuery) return;
        lastFilterQuery = queryString;
      } else {
        lastFilterQuery = null;
      }

      // paged_from only shapes this request. The shareable URL keeps paged alone.
      const startPage = parseInt(fromPage, 10);
      const requestQuery = (startPage > 0 && startPage < page)
        ? queryString + '&paged_from=' + startPage
        : queryString;

      // Conditional logging based on DEBUG_MODE
      if (DEBUG_MODE) {
        console.log('Query String:', queryString);
      } // ENDIF

      // Marketo: emit the settled filter state as a Munchkin page view so the
      // Land Type Interest triggers can qualify. Real filter actions only (not
      // load-more pagination, nor Back and Forward); debounced + de-duped
      // inside the emitter.
      if (filter_type === 'filter' && historyMode !== 'history') {
        window.hhEmitMunchkinFilterView('/home-designs/', queryString);
      }

      const generation = (filter_type === 'filter') ? ++filterGeneration : filterGeneration;

      // Send the AJAX request
      fetch(`${window.location.origin}/wp-admin/admin-ajax.php?action=nous_filter_home_design_filter_grid&${requestQuery}`, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => response.json()) // Parse the response as JSON
        .then(data => {
          if (DEBUG_MODE) {
            console.log('AJAX Response:', data); // DEBUG: Log the entire response
          } // ENDIF

          // A newer request has replaced this one.
          if (generation !== filterGeneration) {
            if (filter_type === 'filter' && lastFilterQuery === queryString) {
              lastFilterQuery = null;
            }
            return;
          }

          // A failed filter must not block a retry of the same query.
          if (!data.success && filter_type === 'filter') {
            lastFilterQuery = null;
          }

          // Check if the AJAX request was successful
          if (data.success) {

            // Append new posts to the grid (relying on .no-results-message in HTML for empty states)
            if (postsGrid) {
              var noResultsBlock = block.querySelector('.no-results-message:not(.no-results-range-message)');

              if (filter_type === 'filter') {
                postsGrid.innerHTML = data.data.cards_html || '';
              } else if (data.data.cards_html) {
                postsGrid.insertAdjacentHTML('beforeend', data.data.cards_html);
              }

              if (filter_type === 'filter') {
                if (!data.data.cards_html) {
                  if (data.data.range_no_results) {
                    // Range + filters produced no results — show range-specific message
                    if (noResultsRangeBlock) noResultsRangeBlock.classList.remove('d-none');
                    if (noResultsBlock) noResultsBlock.classList.add('d-none');
                  } else {
                    // Generic no results
                    if (noResultsBlock) noResultsBlock.classList.remove('d-none');
                    if (noResultsRangeBlock) noResultsRangeBlock.classList.add('d-none');
                  }
                } else {
                  // Has results — hide both messages
                  if (noResultsBlock) noResultsBlock.classList.add('d-none');
                  if (noResultsRangeBlock) noResultsRangeBlock.classList.add('d-none');
                }
              }

              // Re-init variant pills on newly injected cards
              if (window.homeDesignFamily && typeof window.homeDesignFamily.initAllCards === 'function') {
                window.homeDesignFamily.initAllCards();
              }
            }

            // Re-bind favourites for newly injected cards
            if (window.nousFavourites && typeof window.nousFavourites.bindCardButtons === 'function') {
              window.nousFavourites.bindCardButtons();
              if (typeof window.nousFavourites.syncFromCookie === 'function') {
                window.nousFavourites.syncFromCookie();
              }
            }

            // Pagination Update
            if (page < data.data.max_num_pages) {
              pagination_btn.dataset.paged = page;
              pagination_btn.style = '';
            } else {
              pagination_btn.style.display = 'none';
            } // ENDIF

            // Initialize carousels for newly loaded content
            init_home_design_carousels();

            // Initialize custom mouse pointer for newly loaded content
            init_custom_mouse_pointer();

            // Update the browser URL to reflect the current filter state (for sharing)
            const updatedUrl = `?${queryString}`;
            if (historyMode === 'push') {
              pushResultsUrl(updatedUrl);
            } else if (historyMode === 'replace' || historyMode === 'history') {
              history.replaceState(null, '', updatedUrl);
              shownSearch = window.location.search;
            }
            AOS.refreshHard();

          } // ENDIF

        })
        .catch(error => {
          // Handle any AJAX errors. Forget the query so a retry is sent.
          lastFilterQuery = null;
          console.error('Error:', error);
        });

    } // ENDFUNC

    //////////////////////////////////////////////////////////////////////////////
    // Restore results when landing on the page with ?paged=2+
    // (so back-from-favourites shows all previously loaded results)
    //////////////////////////////////////////////////////////////////////////////
    (function restoreFromUrlPagination() {
      var params = new URLSearchParams(window.location.search);

      if (!params || params.size === 0) return;
      if (!filterForm || !postsGrid || !loadMorePostsBtn) return;

      var urlPage = parseInt(params.get('paged'), 10);

      // Only do something for page > 1
      if (!urlPage || urlPage <= 1) return;

      // Update load-more button state
      loadMorePostsBtn.dataset.paged = urlPage;

      // The server rendered page 1. Append pages 2..urlPage with one request,
      // so they arrive in order. The URL already names these results, so the
      // entry is rewritten rather than duplicated, which would make Back
      // appear to do nothing.
      filterPosts(urlPage, loadMorePostsBtn, 'pagination', 2, 'replace');

      // Scroll user back to filter block once restored
      scrollToFilterBlock(true);
    })();  // ENDFUNC

    /**
     * Sets a select to a value from the URL, or to its first option when the
     * URL has none or one it does not offer.
     *
     * @since 1.1.2
     * @param {HTMLSelectElement} select
     * @param {?string} value
     * @returns {void}
     */
    function setSelectFromParam(select, value) {
      if (!select || !select.options.length) return;

      var offered = Array.prototype.some.call(select.options, function (option) {
        return option.value === value;
      });
      select.value = offered ? value : select.options[0].value;

      // The has-selection styling normally follows a change event, which here
      // would start another filter.
      if (select.classList.contains('form-select')) {
        var selected = select.options[select.selectedIndex];
        select.classList.toggle('has-selection', !!selected && !selected.hasAttribute('default'));
      }
    }

    /**
     * Sets every filter control to the state in a URL's query string. Values
     * are assigned directly, so none of the change handlers that start a
     * filter run.
     *
     * @since 1.1.2
     * @param {URLSearchParams} params
     * @returns {void}
     */
    function applyParamsToForm(params) {
      if (!filterForm) return;

      var homeName = filterForm.querySelector('#home-name');
      if (homeName) {
        homeName.value = params.get('home-name') || '';
      }

      var range = params.get('hh-range') || '';
      filterForm.querySelectorAll('input[name="hh-range"]').forEach(function (radio) {
        radio.checked = radio.value === range;
      });

      // Bedrooms, bathrooms, garage spaces and living areas: a hidden select,
      // shown as the text box the minus and plus buttons step through.
      filterForm.querySelectorAll('.js-filter-qty-select').forEach(function (qty) {
        var option = qty.closest('.js-filter-option');
        var select = option ? option.querySelector('select') : null;
        var display = qty.querySelector('input');
        if (!select) return;

        setSelectFromParam(select, params.get(select.name));
        if (display && select.selectedIndex >= 0) {
          display.value = select.options[select.selectedIndex].textContent.trim();
        }
      });

      setSelectFromParam(filterForm.querySelector('select[name="lot-width"]'), params.get('lot-width'));
      setSelectFromParam(sortSelect, params.get('sort-by'));

      // An input event redraws a range slider without filtering: only a click
      // on its rail starts a filter.
      filterForm.querySelectorAll('.js-range-slider').forEach(function (wrap) {
        var minRange = wrap.querySelector('.js-range-slider-min');
        var maxRange = wrap.querySelector('.js-range-slider-max');
        if (!minRange || !maxRange) return;

        minRange.value = params.get(minRange.name) || wrap.dataset.min;
        maxRange.value = params.get(maxRange.name) || wrap.dataset.max;
        minRange.dispatchEvent(new Event('input', { bubbles: true }));
        maxRange.dispatchEvent(new Event('input', { bubbles: true }));
      });

      var pagedField = filterForm.querySelector('input[name="paged"]');
      if (pagedField) {
        pagedField.value = Math.max(1, parseInt(params.get('paged'), 10) || 1);
      }

      if (window.jQuery && jQuery.fn.chosen) {
        jQuery(filterForm).find('select').add(sortSelect || []).trigger('chosen:updated');
      }
    }

    //////////////////////////////////////////////////////////////////////////////
    // Back and Forward: filtering pushes a history entry per result set, so
    // redraw the filters and results the entry's URL names. Pages 1..N come
    // back in one request, replacing the grid. The entry is then rewritten to
    // the query actually drawn, so the URL and the grid always agree.
    //////////////////////////////////////////////////////////////////////////////
    if (filterForm && postsGrid && loadMorePostsBtn) {
      window.addEventListener('popstate', function () {
        if (window.location.search === shownSearch) return;
        shownSearch = window.location.search;

        var params = new URLSearchParams(shownSearch);
        var page = Math.max(1, parseInt(params.get('paged'), 10) || 1);

        applyParamsToForm(params);
        loadMorePostsBtn.dataset.paged = page;
        lastFilterQuery = null;
        filterPosts(page, loadMorePostsBtn, 'filter', 1, 'history');
      });
    }
  });
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Initialize Home Design Carousels
////////////////////////////////////////////////////////////////////////////////////
function init_home_design_carousels() {
  (function($) {

    $('.js-home-design-carousel').each(function() {
      var $carousel = $(this);

      // Initialize Flickity
      $carousel.flickity({
        cellSelector: '.carousel-cell',
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        imagesLoaded: true,
        arrowShape: 'm25.21,44.06h66.35c3.28,0,5.94,2.66,5.94,5.94s-2.66,5.94-5.94,5.94H25.21l29.02,29.02c2.33,2.33,2.31,6.11-.04,8.42-2.32,2.28-6.05,2.26-8.35-.04L2.5,50,45.84,6.66c2.3-2.3,6.03-2.32,8.35-.04,2.35,2.31,2.37,6.09.04,8.42l-29.02,29.02Z'
      });

      // Update slide counter on change
      $carousel.on('change.flickity', function(event, index) {
        var currentSlide = index + 1;
        $carousel.find('.js-current-slide').text(currentSlide);
      });

      // Trigger initial counter update
      $carousel.on('ready.flickity', function() {
        $carousel.trigger('change.flickity', [0]);
      });
    });

  })(jQuery);
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Initialize Search Display Homes Carousel
////////////////////////////////////////////////////////////////////////////////////
function init_search_dh_carousel() {
  (function($) {

    $('.js-search-display-homes').each(function() {
      var $carousel = $(this);

      // Initialize Flickity
      var flkty = $carousel.flickity({
        cellSelector: '.carousel-cell',
        cellAlign: 'center',
        contain: true,
        wrapAround: true,
        pageDots: false,
        prevNextButtons: true,
        imagesLoaded: true,
        arrowShape: 'm25.21,44.06h66.35c3.28,0,5.94,2.66,5.94,5.94s-2.66,5.94-5.94,5.94H25.21l29.02,29.02c2.33,2.33,2.31,6.11-.04,8.42-2.32,2.28-6.05,2.26-8.35-.04L2.5,50,45.84,6.66c2.3-2.3,6.03-2.32,8.35-.04,2.35,2.31,2.37,6.09.04,8.42l-29.02,29.02Z'
      });

      $(window).on('resize', function() {
        clearTimeout($carousel.data('resizeTimeout')); // debounce resize
        $carousel.data('resizeTimeout', setTimeout(function() {
          flkty.flickity('resize'); // recalculates height & layout
        }, 250));
      });

    });

  })(jQuery);
}

function flexi_display_homes_filter_grid() {
  DEBUG_MODE = false; // Set to true to enable detailed logging

  var flexi_display_homes_filter_grid = document.querySelectorAll('.section-flexi-display-homes-filter-grid');
  flexi_display_homes_filter_grid.forEach(function(block) {
    init_search_dh_carousel();
  });

}
////////////////////////////////////////////////////////////////////////////////////



////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Home Filter Grid
////////////////////////////////////////////////////////////////////////////////////
function flexi_house_and_land_filter_grid() {
  DEBUG_MODE = false; // Set to true to enable detailed logging

  var flexi_house_and_land_filter_grid = document.querySelectorAll('.section-flexi-house-and-land-filter-grid');
  flexi_house_and_land_filter_grid.forEach(function(block) {
    const mapConfig = {
      icons: {
        active: '/wp-content/themes/hallmarkhomes/assets/img/hal-marker-active.svg',
        inactive: '/wp-content/themes/hallmarkhomes/assets/img/hal-marker-inactive.svg',
      },
      radius: 30000,
    };

    let map;

    var filterBlock = block.querySelector('.js-filter-block');
    var filterForm = filterBlock ? filterBlock.querySelector('.js-filter-form') : null;


    // ---------------------
    // RANGE FIELDS
    // ---------------------
    var filterPriceSelect = filterForm ? filterForm.querySelector('.js-range-slider-min, .js-range-slider-max') : null;
    var filterPriceRangeMin = filterForm.querySelector('.js-range-slider-min');
    var filterPriceRangeMax = filterForm.querySelector('.js-range-slider-max');
    


    var filterBlockTrigger = block.querySelectorAll('.js-filter-sticky-scroll-trigger');

    var postsGrid = block.querySelector('.js-posts-cards');
    var resetFilterBtn = block.querySelectorAll('.js-reset-filters');
    var applyFilterBtn = block.querySelectorAll('.js-filter-hl');
    var loadMorePostsBtn = block.querySelector('.js-load-posts');

    if (DEBUG_MODE) {
      console.log('mapData: ', mapData);
    }

    ////////////////////////////////////////////////////////////////////////////////////
    // Filter Posts
    // filter_type = 'filter|pagination';
    ////////////////////////////////////////////////////////////////////////////////////
    function filterPosts(page = 1, pagination_btn, filter_type) {

      const DEBUG_MODE = false;
      const formData = new FormData(filterForm); // Serialise form data
      formData.set('paged', page); // Set the current page number in the form

      // Create a new FormData object with only non-empty values
      const filteredFormData = new FormData();
      for (let [key, value] of formData.entries()) {
        if (value !== '' && value !== null && value !== undefined) {
          filteredFormData.append(key, value);
        }
      } // ENDFOR

      // Strip range slider values at their default positions (= no filter intended)
      // When a slider is at its min/max extreme, omit it so the PHP handler
      // treats it as "no filter" (the same as the initial server-side render).
      block.querySelectorAll('.js-range-slider').forEach(function (wrap) {
        const minRange = wrap.querySelector('.js-range-slider-min');
        const maxRange = wrap.querySelector('.js-range-slider-max');
        if (minRange && parseFloat(minRange.value) <= parseFloat(minRange.min)) {
          filteredFormData.delete(minRange.name);
        }
        if (maxRange && parseFloat(maxRange.value) >= parseFloat(maxRange.max)) {
          filteredFormData.delete(maxRange.name);
        }
      });

      // Convert filtered form data to a query string
      const queryString = new URLSearchParams(filteredFormData).toString();

      // Conditional logging based on DEBUG_MODE
      if (DEBUG_MODE) {
        for (let [key, value] of filteredFormData.entries()) {
          console.log(`FormData entry: ${key} = ${value}`);
        } // ENDFOR

        console.log('Query String:', queryString);
      } // ENDIF

      // Marketo: emit the settled filter state as a Munchkin page view. Not used
      // by the current Land Type Interest nurture (home-designs only), but sent
      // so the signal is available for any future house-and-land nurture. Real
      // filter actions only; debounced + de-duped inside the emitter.
      if (filter_type === 'filter') {
        window.hhEmitMunchkinFilterView('/house-and-land/', queryString);
      }

      // Send the AJAX request
      fetch(`${window.location.origin}/wp-admin/admin-ajax.php?action=nous_filter_house_and_land_filter_grid&${queryString}`, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => response.json()) // Parse the response as JSON
        .then(data => {
          if (DEBUG_MODE) {
            console.log('AJAX Response:', data); // DEBUG: Log the entire response
          } // ENDIF

          // Check if the AJAX request was successful
          if (data.success) {

            // Append new posts to the grid
            if (postsGrid && data.data.cards_html) {
              if (filter_type === 'filter') {
                postsGrid.innerHTML = data.data.cards_html;
              } else {
                postsGrid.insertAdjacentHTML('beforeend', data.data.cards_html);
              }
            } else if (postsGrid) {
              postsGrid.innerHTML = '<span class="d-block h4">No Locations Found</span>';
            } // ENDIF

            // Pagination Update
            if (page < data.data.max_num_pages) {
              pagination_btn.dataset.paged = page;
              pagination_btn.style = '';
            } else {
              pagination_btn.style.display = 'none';
            } // ENDIF

            // Merge both arrays, removing duplicates by ID
            if (data.data.map_data) {

              if (filter_type === 'filter') {
                newMapData = data.data.map_data;

              } else {
                // Create a combined array
                var existingIds = mapData.map(item => item.id);
                var newItems = data.data.map_data.filter(item => !existingIds.includes(item.id));
                newMapData = mapData.concat(newItems);

              }

              initialiseMapAndMarkers(newMapData);
            }

            // Initialize custom mouse pointer for newly loaded content
            init_custom_mouse_pointer();

            // Update the browser URL to reflect the current filter state (for sharing)
            const updatedUrl = `?${queryString}`;
            history.pushState(null, '', updatedUrl);
            AOS.refreshHard();

          } // ENDIF

        })
        .catch(error => {
          // Handle any AJAX errors
          console.error('Error:', error);
        });

    } // ENDFUNC
    ////////////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////////////
    // Scroll to Filter Block
    ////////////////////////////////////////////////////////////////////////////////////
    

    function scrollToFilterBlock() {
      const el = document.querySelector('.section-flexi-house-and-land-filter-grid');
      if (!el) return;
      const header = document.querySelector('header');
      const headerHeight = header ? header.offsetHeight : 0;
      const top = window.scrollY + el.getBoundingClientRect().top - headerHeight - 50;
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    }



    function debounce(fn, wait) {
      let t;
      return function () {
        const ctx = this, args = arguments;
        clearTimeout(t);
        t = setTimeout(() => fn.apply(ctx, args), wait);
      };
    }

    ////////////////////////////////////////////////////////////////////////////////////
    // Filter Event Listeners
    ////////////////////////////////////////////////////////////////////////////////////

    // Live filtering (works for Chosen + native selects + qty +/-)
    if (filterForm) {
      const $ = jQuery;
      const $form = $(filterForm);

      const runLiveFilter = (function () {
        let t;
        return function () {
          clearTimeout(t);
          t = setTimeout(function () {
            if (loadMorePostsBtn) {
              loadMorePostsBtn.dataset.paged = 1;
              loadMorePostsBtn.style.display = '';
            }

            filterPosts(1, loadMorePostsBtn, 'filter');
            //scrollToFilterBlock();
          }, 300);
        };
      })();

      // Catch BOTH native change + jQuery-triggered change (Chosen triggers jQuery change)
      $form.on('change', 'select', function () {
        runLiveFilter();
      });

      // Optional: if any text inputs are added later
      $form.on('input', 'input[type="text"], input[type="search"]', function () {
        runLiveFilter();
      });

      // Prevent full page submit refresh
      $form.on('submit', function (e) {
        e.preventDefault();
        runLiveFilter();
      });
    }





    if (filterBlockTrigger) {
      filterBlockTrigger.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();

          document.querySelector('body').classList.toggle('no-scroll');
          filterBlock.classList.toggle('active');
        });
      });
    }

    if (applyFilterBtn) {
      applyFilterBtn.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
          e.preventDefault();
          var currentPage = parseInt(loadMorePostsBtn.dataset.paged) || 1;

          filterPosts(currentPage, loadMorePostsBtn, 'filter');

          scrollToFilterBlock();
        });
      });
    }

    // Load more posts button event handler
    if (loadMorePostsBtn) {
      loadMorePostsBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var currentPage = parseInt(loadMorePostsBtn.dataset.paged) || 1;
        var nextPage = currentPage + 1;

        if (DEBUG_MODE) {
          console.log('Load More Posts Clicked');
          console.log('Current Page:', currentPage);
          console.log('Next Page:', nextPage);
        } // ENDIF

        filterPosts(nextPage, loadMorePostsBtn, 'pagination');

      });
    } // ENDIF

    // Reset filter button event handler
    if (resetFilterBtn) {
      resetFilterBtn.forEach(function(trigger) {
        trigger.addEventListener('click', function(e) {
        e.preventDefault();

        // Reset the form first
        filterForm.reset();

        // Reset ALL range sliders
        filterForm.querySelectorAll('.js-range-slider').forEach(function (wrap) {
          const min = parseFloat(wrap.dataset.min);
          const max = parseFloat(wrap.dataset.max);

          const minRange = wrap.querySelector('.js-range-slider-min');
          const maxRange = wrap.querySelector('.js-range-slider-max');

          if (!minRange || !maxRange) return;

          minRange.value = min;
          maxRange.value = max;

          minRange.dispatchEvent(new Event('input', { bubbles: true }));
          maxRange.dispatchEvent(new Event('input', { bubbles: true }));
        });



        var selectFields = filterForm.querySelectorAll('.js-filter-option');
        selectFields.forEach(function(select) {
          var selection = select.querySelector('select');
          var selectionInput = select.querySelector('.js-filter-qty-select');

          selection.querySelectorAll('option').forEach(function(option) {
            option.removeAttribute('selected');
          });

          selection.selectedIndex = 0; // Reset to first option
          jQuery(selection).trigger('chosen:updated');
          jQuery(selection).trigger('change');

          // Set selected attribute on first option and update input value
          if (selection.options[0] && selectionInput) {
            var firstOptionText = selection.options[0].textContent.trim();
            var inputElement = selectionInput.querySelector('input');

            selection.options[0].setAttribute('selected', 'selected');

            if (inputElement) {
              inputElement.value = firstOptionText;
            }
          }
        });

        //scrollToFilterBlock();

        // Clear all query string parameters from URL
        const baseUrl = window.location.origin + window.location.pathname;
        history.pushState(null, '', baseUrl);

        filterPosts(1, loadMorePostsBtn, 'filter');

        });
      });
    } // ENDIF

    // Minus buttons event handlers
    block.querySelectorAll('.js-filter-qty-select .js-minus').forEach(function(minusBtn) {
      minusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var qtySelectWrapper = this.closest('.js-filter-qty-select');
        var currentSelection = qtySelectWrapper.querySelector('input').value.toLowerCase().replace(/[^a-z0-9]/g, '');
        var filterOption = qtySelectWrapper.closest('.js-filter-option');
        var filterSelect = filterOption.querySelector('select');

        var options = filterSelect.querySelectorAll('option');
        for (var i = 0; i < options.length; i++) {
          var optionValue = options[i].value.toLowerCase().replace(/[^a-z0-9]/g, '');

          if (optionValue === currentSelection) {
            var previousOption = options[i - 1];

            if (previousOption) {
              var inputElement = qtySelectWrapper.querySelector('input');
              var cleanText = previousOption.textContent.trim();

              inputElement.value = cleanText;
              filterSelect.value = previousOption.value;

              // Trigger change event
              var changeEvent = new Event('change', { bubbles: true });
              filterSelect.dispatchEvent(changeEvent);
              break; // Exit the loop once the match is found
            }
          }
        }
      });
    });

    // Plus buttons event handlers
    block.querySelectorAll('.js-filter-qty-select .js-plus').forEach(function(plusBtn) {
      plusBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var qtySelectWrapper = this.closest('.js-filter-qty-select');
        var currentSelection = qtySelectWrapper.querySelector('input').value.toLowerCase().replace(/[^a-z0-9]/g, '');
        var filterOption = qtySelectWrapper.closest('.js-filter-option');
        var filterSelect = filterOption.querySelector('select');

        var options = filterSelect.querySelectorAll('option');
        for (var i = 0; i < options.length; i++) {
          var optionValue = options[i].value.toLowerCase().replace(/[^a-z0-9]/g, '');

          if (optionValue === currentSelection) {
            var nextOption = options[i + 1];

            if (nextOption) {
              var inputElement = qtySelectWrapper.querySelector('input');
              var cleanText = nextOption.textContent.trim();

              inputElement.value = cleanText;
              filterSelect.value = nextOption.value;

              // Trigger change event
              var changeEvent = new Event('change', { bubbles: true });
              filterSelect.dispatchEvent(changeEvent);
              break; // Exit the loop once the match is found
            }
          }
        }
      });
    });
    ////////////////////////////////////////////////////////////////////////////////////



    ////////////////////////////////////////////////////////////
    // PRICE FILTER CHANGE: ON CHANGE EVENT
    ////////////////////////////////////////////////////////////
    if (filterPriceSelect) {
      let lastMin, lastMax;
      // runs filterPosts only after the slider stops changing
      const debounce = (fn, wait = 400) => {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn(...args), wait);
        };
      };
      const runFilterDebounced = debounce((source) => {
        //if (source === 'rail') { // Run only on rail click
          filterPosts(1, loadMorePostsBtn, 'filter');
        //}
      }, 600);
      

      document.querySelectorAll('.js-range-slider').forEach(function (wrap) {
        wrap.addEventListener('range-slider:change', function (e) {
          const { min, max, source } = e.detail;
          //console.log('Slider changed:', min, max, source);
          runFilterDebounced(source);
        });
      });

    }
    //--------------------------------------



    ////////////////////////////////////////////////////////////////////////////////////
    // Block Tab Event Listener
    ////////////////////////////////////////////////////////////////////////////////////
    function tabEventListener() {
      const tabButtons = block.querySelectorAll('.js-content-tab');
      tabButtons.forEach(button => {
        button.addEventListener('click', () => {
          const contentId = button.getAttribute('data-id');

          // Deactivate all tabs
          tabButtons.forEach(btn => btn.classList.remove('active'));

          // Activate the clicked tab
          button.classList.add('active');

          // Hide all content sections
          const allContents = block.querySelectorAll('.js-tab-content');
          allContents.forEach(content => {
            content.classList.remove('active');
          });

          block.querySelector(`div#${contentId}`).classList.add('active');

          setTimeout(function(){
            refreshAOS();
          },500);

          // block.querySelector(`div#${contentId}`).classList.remove('d-none');
          // block.querySelector(`div#${contentId}`).classList.add('d-flex');
        });
      });
    }
    tabEventListener();
    ////////////////////////////////////////////////////////////////////////////////////

    ////////////////////////////////////////////////////////////////////////////////////
    // Google Map Block
    ////////////////////////////////////////////////////////////////////////////////////
    var mapElement= null;
    function initialiseMap() {
      // Map Options
      mapElement = block.querySelector('.js-hl-map');
      const initialCenter = { lat: -27.3817412, lng: 152.8283958 };
      const initialZoom = 10;

      if (mapElement) {
        // Get the map ID or use a default fallback
        const mapId = mapElement.getAttribute('id');

        // Create a new Google Map instance
        map = new google.maps.Map(mapElement, {
          zoom: initialZoom,
          center: initialCenter,
          // styles: mapConfig.styles,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          scaleControl: false,
          rotateControl: false,
          zoomControl: true,
          cameraControl: true,
          mapId: mapId
        });
      } // ENDIF

    } // ENDFUNC

    ////////////////////////////////////////////////////////////////////////////////////
    // Helper: Build Info Window HTML for House & Land map
    ////////////////////////////////////////////////////////////////////////////////////
    function buildHlInfoWindowContent(item) {
      var feature_image = item && item.feature_image ? item.feature_image : '';
      var title = item && item.title ? item.title : '';
      var subheading = item && item.subheading ? item.subheading : '';
      var price_heading = item && item.price_heading ? item.price_heading : '';
      var features = (item && Array.isArray(item.features)) ? item.features : [];
      var url = item && item.url ? item.url : '';

      var infoContent = `
        <div class="info-content">
          <div class="info-content-header">
            <img src="${feature_image}" alt="${title}" class="img-fluid" />
          </div>
          <div class="info-content-body">
            <p class="body-small text-uppercase mb-0">${title}</p>
            <p class="body-small fw-bold mb-0">${subheading}</p>
            <p class="body-small fw-bold mb-0">${price_heading}</p>
            <div class="property-info d-flex gap-3">
      `;

      features.forEach(function(feature) {
        var icon = feature && feature.icon ? feature.icon : '';
        var number = (feature && feature.number !== undefined && feature.number !== null) ? feature.number : '';
        infoContent += `
          <div class="property-feature">
            <span class="${icon} property-feature-icon"></span>
            <span class="h5 mb-0 ms-1 property-feature-text">${number}</span>
          </div>
        `;
      });

      infoContent += `</div>`; // Property Info
      infoContent += `</div>`; // Info Content Body
      infoContent += `<a href="${url}" class="stretched-link"></a>`;
      infoContent += `</div>`; // Info Content

      return infoContent;
    }

    function createMarkers(mapData) {
      // Check if map exists before creating markers
      if (!map) {
        console.warn('Map not initialized yet, cannot create markers');
        return;
      }

      // Check if mapData is available and has items
      if (typeof mapData !== 'undefined' && mapData && mapData.length > 0) {
        var bounds = new google.maps.LatLngBounds();
        var currentInfoWindow = null; // Track currently open info window

        // Fit map to show all markers with sensible zoom handling
        var validMarkerCount = 0;
        var firstPosition = null;

        mapData.forEach(function(item) {
          // Parse coordinates (they come as strings)
          var lat = parseFloat(item.lat);
          var lng = parseFloat(item.lng);

          if (!isNaN(lat) && !isNaN(lng)) {
            var position = new google.maps.LatLng(lat, lng);

            var feature_image = item.feature_image;
            var title = item.title;
            var subheading = item.subheading;
            var price_heading = item.price_heading;
            var features = item.features;

            // Determine if marker should be active or inactive
            // You can customize this logic based on your needs
            var iconType = item.active === true || item.active === 'true' ? 'active' : 'inactive';

            // Create custom icon with size specifications
            var customIcon = {
              url: mapConfig.icons[iconType],
              scaledSize: new google.maps.Size(25, 25),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(12.5, 25)
            };

            var marker = new google.maps.Marker({
              position: position,
              map: map,
              title: title,
              icon: customIcon
            });

            if (!isNaN(lat) && !isNaN(lng)) {
              if (validMarkerCount === 0) {
                firstPosition = new google.maps.LatLng(lat, lng);
              }

              validMarkerCount++;
            }

            // Store reference to marker in the data item for later access
            item.marker = marker;

            bounds.extend(position);

            // Create info window with property details (using helper)
            var infoWindow = new google.maps.InfoWindow({
              content: buildHlInfoWindowContent(item)
            });

            // Listen for info window close event
            infoWindow.addListener('closeclick', function() {
              // Set this marker back to inactive when info window is closed
              var inactiveIcon = {
                url: mapConfig.icons.inactive,
                scaledSize: new google.maps.Size(25, 25),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(12.5, 25)
              };
              marker.setIcon(inactiveIcon);
              currentInfoWindow = null;
            });



            marker.addListener('click', function() {
              // Close any currently open info window
              if (currentInfoWindow) {
                currentInfoWindow.close();
              }

              // Set all markers to inactive first (optional - only if you want one active at a time)
              // You can remove this section if you want multiple active markers
              mapData.forEach(function(otherItem, index) {
                if (otherItem.marker) {
                  var inactiveIcon = {
                    url: mapConfig.icons.inactive,
                    scaledSize: new google.maps.Size(25, 25),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(12.5, 25)
                  };
                  otherItem.marker.setIcon(inactiveIcon);
                }
              });

              // Set this marker as active
              var activeIcon = {
                url: mapConfig.icons.active,
                scaledSize: new google.maps.Size(25, 25),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(12.5, 25)
              };
              marker.setIcon(activeIcon);

              // Open the new info window and track it
              infoWindow.open(map, marker);
              currentInfoWindow = infoWindow;
            });


            marker.addListener('click', function() {
              if (currentInfoWindow) {
                currentInfoWindow.close();
              }
              infoWindow.open(map, marker);
              currentInfoWindow = infoWindow;
            });

            // Close info window if clicking on the map
            google.maps.event.addListener(map, 'click', function() {
              if (currentInfoWindow) {
                currentInfoWindow.close();
                currentInfoWindow = null;
              }
            });

            // Close info window if clicking anywhere else on the document
            document.addEventListener('click', function(e) {
              const mapContainer = map.getDiv();
              if (!mapContainer.contains(e.target)) {
                if (currentInfoWindow) {
                  currentInfoWindow.close();
                  currentInfoWindow = null;
                }
              }
            });
            

          } // ENDIF
        });

        if (validMarkerCount === 0) {
          // No markers: reset to a sensible default view
          map.setCenter({ lat: -27.3817412, lng: 152.8283958 });
          map.setZoom(10);
        } else if (validMarkerCount === 1 && firstPosition) {
          // Single marker: center map and set a reasonable zoom
          map.setCenter(firstPosition);
          map.setZoom(12);
        } else {
          // Multiple markers: fit bounds and clamp the resulting zoom
          try {
            // Use uniform padding where available
            if (map.fitBounds.length >= 2) {
              map.fitBounds(bounds, 60);
            } else {
              map.fitBounds(bounds);
            }
          } catch (e) {
            map.fitBounds(bounds);
          }

          // Clamp zoom after bounds settle
          google.maps.event.addListenerOnce(map, 'idle', function() {
            var maxZoom = 15;
            var minZoom = 6;
            var currentZoom = map.getZoom();
            if (currentZoom > maxZoom) map.setZoom(maxZoom);
            if (currentZoom < minZoom) map.setZoom(minZoom);
          });
        } // ENDIF

        return;
      }

    } // ENDFUNC

    function initialiseMapAndMarkers(mapData) {
      // First initialize the map
      initialiseMap();

      // Then create markers after map is ready
      setTimeout(function() {
        createMarkers(mapData);
      }, 100);

    } // ENDFUNC

    function checkGoogleMaps() {
      // Check if the Google Maps API is available
      if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
        // Google Maps API is loaded, initialise the map and markers
        initialiseMapAndMarkers(mapData);
      } else {
        // Google Maps API is not loaded, retry after a delay
        setTimeout(checkGoogleMaps, 1000);
      }
    } // ENDFUNC

    checkGoogleMaps();
    ////////////////////////////////////////////////////////////////////////////////////

  });

}


////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Display Homes
////////////////////////////////////////////////////////////////////////////////////
function flexi_display_homes_block() {

  DEBUG_MODE = false; // Set to true to enable detailed logging
  
  var flexi_display_homes_block = document.querySelectorAll('.section-flexi-display-homes-filter-grid');
  flexi_display_homes_block.forEach(function(block) {

    const applyFilterBtn = block.querySelector('.js-dh-filter') ? block.querySelector('.js-dh-filter') : null;

    const filterForm = block.querySelector('.js-filter-block-form') ? block.querySelector('.js-filter-block-form') : null;
    const postsGrid = block.querySelector('.js-posts-cards') ? block.querySelector('.js-posts-cards') : null;
    const paginationContainer = block.querySelector('.js-section-pagination') ? block.querySelector('.js-section-pagination') : null;
    const paginationContainerInner = paginationContainer ? paginationContainer.querySelector('.js-pagination') : null;

    if (DEBUG_MODE) {
      console.group('flexi_display_homes_block');
      console.log('filterForm: ', filterForm);
      console.log('postsGrid: ', postsGrid);
      console.log('paginationContainer: ', paginationContainer);
      console.log('paginationContainerInner: ', paginationContainerInner);
      console.groupEnd();
    } // ENDIF

    if (applyFilterBtn) {
      applyFilterBtn.addEventListener('click', function (e) {
        e.preventDefault();

        // let
        let action = this.parentElement.getAttribute('action') ?? null;
        console.log('action: ', action);

        if (action != null) {
          const elementId = this.parentElement.getAttribute('data-id') ?? null;
          const formData = new FormData(filterForm); // Serialise form data
          const queryString = new URLSearchParams(formData).toString();
          const actionWithQuery = queryString ? `${action}?${queryString}#${elementId}` : action;

          window.location.href = actionWithQuery;
        } else {

          filterPosts(1);
          setTimeout(scrollToTop, 300);
        }
      });
    }

    function scrollToTop() {
      if(postsGrid) {
        var header = document.querySelector('header');
        var headerOuterHeight = 0;
        if (header) {
          headerOuterHeight = header.offsetHeight;
        }

        window.scrollTo({
          top: postsGrid.offsetTop - headerOuterHeight - 50,
          behavior: 'smooth'
        });
      }
    } // ENDFUNC

    function bindPaginationEvents() {
      if (paginationContainer) {
        const paginationLinks = paginationContainer.querySelectorAll('a');
        paginationLinks.forEach(link => {
          link.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default link behavior

            const page = new URL(link.href).searchParams.get('paged'); // Extract the page number
            filterPosts(page); // Fetch the content for the selected page

            setTimeout(scrollToTop, 300);
          });
        });
      }
    } // ENDFUNC

    function filterPosts(page = 1) {
      const formData = new FormData(filterForm); // Serialise form data
      formData.set('paged', page); // Set the current page number in the form

      const queryString = new URLSearchParams(formData).toString();

      if (DEBUG_MODE) {
        console.log('AJAX Request:', queryString);
      }

      // Send the AJAX request
      fetch(`${window.location.origin}/wp-admin/admin-ajax.php?action=nous_display_homes_filter&${queryString}`, {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
        .then(response => response.json()) // Parse the response as JSON
        .then(data => {
          if (DEBUG_MODE) {
            console.log('AJAX Response:', data); // DEBUG: Log the entire response
          } // ENDIF

          // Check if the AJAX request was successful
          if (data.success) {

            if (postsGrid && data.data.cards_html) {
              postsGrid.innerHTML = data.data.cards_html;

              init_search_dh_carousel();

              // Re-bind favourites for newly injected cards (if any use favourites)
              if (window.nousFavourites && typeof window.nousFavourites.bindCardButtons === 'function') {
                window.nousFavourites.bindCardButtons();
                if (typeof window.nousFavourites.syncFromCookie === 'function') {
                  window.nousFavourites.syncFromCookie();
                }
              }
            } else if (postsGrid) {
              postsGrid.innerHTML = '<p>No posts found.</p>'; // Show 'No posts found' if no results
            } // ENDIF

            if (paginationContainerInner && data.data.pagination_html) {
              paginationContainerInner.innerHTML = data.data.pagination_html;
              // Rebind pagination events after pagination controls are updated
              bindPaginationEvents();
            } else if (paginationContainerInner) {
              paginationContainerInner.innerHTML = ''; // Clear pagination info if no results
            } // ENDIF

            // Update the browser URL to reflect the current filter state (for sharing)
            const updatedUrl = `?${queryString}`;
            history.pushState(null, '', updatedUrl);
            AOS.refreshHard();

            setTimeout(scrollToTop, 300);

          } // ENDIF

        })
        .catch(error => {
          // Handle any AJAX errors
          console.error('Error:', error);
        });
    } // ENDFUNC

    ////////////////////////////////////////////////////////////////////////////////////
    // Map FUNCTIONS
    ////////////////////////////////////////////////////////////////////////////////////
    const mapConfig = {
      // styles: mapStyle,
      icons: {
        active: '/wp-content/themes/hallmarkhomes/assets/img/hal-marker-active.svg',
        inactive: '/wp-content/themes/hallmarkhomes/assets/img/hal-marker-inactive.svg',
      },
      radius: 30000,
    };

    //var map;

    function initialiseMap() {
      // Map Options
      var mapElement = block.querySelector('.js-dh-map');
      const initialCenter = { lat: -27.3817412, lng: 152.8283958 };
      const initialZoom = 10;

      if (mapElement) {
        // Get the map ID or use a default fallback
        const mapId = mapElement.getAttribute('id');

        // Create a new Google Map instance
        map = new google.maps.Map(mapElement, {
          zoom: initialZoom,
          center: initialCenter,
          // styles: mapConfig.styles,
          streetViewControl: false,
          mapTypeControl: false,
          fullscreenControl: false,
          scaleControl: true,
          rotateControl: false,
          zoomControl: true,
          cameraControl: true,
          mapId: mapId
        });
      } // ENDIF

    } // ENDFUNC

    function createMarkers(mapData) {
      // Check if map exists before creating markers
      if (!map) {
        console.warn('Map not initialized yet, cannot create markers');
        return;
      }

      console.log("createMarkers: [mapData] ", mapData);

      // Check if mapData is available and has items
      if (typeof mapData !== 'undefined' && mapData && mapData.length > 0) {
        bounds = new google.maps.LatLngBounds();
        var validMarkerCount = 0;
        var firstPosition = null;

        mapData.forEach(function(item) {
          // Parse coordinates (they come as strings)
          var lat = parseFloat(item.lat);
          var lng = parseFloat(item.lng);

          if (!isNaN(lat) && !isNaN(lng)) {
            var position = new google.maps.LatLng(lat, lng);

            // Determine if marker should be active or inactive
            var iconType = item.active === true || item.active === 'true' ? 'active' : 'inactive';

            // Create custom icon with size specifications
            var customIcon = {
              url: mapConfig.icons[iconType],
              scaledSize: new google.maps.Size(25, 25),
              origin: new google.maps.Point(0, 0),
              anchor: new google.maps.Point(12.5, 25)
            };

            var marker = new google.maps.Marker({
              position: position,
              map: map,
              icon: customIcon
            });

            //-----------------------------------------------------------



            if(item.type == 'search'){
              var infoWindow = new google.maps.InfoWindow({
                content: `
                  <div class="dh-infowindow">
                    <div class="dh-infowindow__title fw-bold mb-2">${item.title || ''}</div>
                    <div class="dh-infowindow__opening mb-2">${item.opening || ''}</div>
                    <div class="dh-infowindow__address mb-2">${item.address || ''}</div>
                    <a href="${item.link || ''}" 
                      target="_self"
                      rel="noopener"
                      tabindex="-1">
                      See Details
                    </a>
                    <!--
                    <a class="dh-infowindow__directions_button d-block mt-2"
                      href="https://www.google.com/maps/dir/?api=1&destination=${item.lat},${item.lng}"
                      target="_blank"
                      rel="noopener"
                      tabindex="-1">
                      Get Directions
                    </a>
                    -->
                  </div>
                `
              });

              // Optional: click marker to open its info window and sync the card
              google.maps.event.addListener(marker, 'click', function () {
                // Close all existing info windows
                displayHomesLocations.forEach(function(x){
                  if (x.infoWindow) x.infoWindow.close();
                });
                infoWindow.open(map, marker);

                // jQuery: show the matching card
                jQuery('.card-search-display-homes').hide();
                jQuery(`[data-location-id="${item.id}"]`).show();
              });

              // IMPORTANT: store it in your array item so your nearest-logic can open/close it
              displayHomesLocations.push({
                id: item.id,
                lat: item.lat,
                lng: item.lng,
                marker: marker,
                infoWindow: infoWindow
              });
            
            }

            //----------------------------------------------------------





            // Store reference to marker in the data item for later access
            item.marker = marker;
            item.marker._locationId = item.id;  // ← Display Centre ID

            displayHomesLocations.push({
              id: item.id,
              lat: item.lat,
              lng: item.lng,
              marker: marker
            });

            // Track bounds and counts
            bounds.extend(position);
            if (validMarkerCount === 0) {
              firstPosition = position;
            }
            validMarkerCount++;

          } // ENDIF


          //scroll to related display home listing
          jQuery(document).on('click','.dh-infowindow__details_button',function(){
            const locationId = jQuery(this).data('infowindow-id');
            const $target = jQuery('[data-location-id="' + locationId + '"]');
            if (!$target.length) return;
            const offset = 120; // adjust for fixed header
            const top = $target.offset().top - offset;
            jQuery(window).scrollTop(top);
          });

          //scroll to related display home listing
          if(item.type == 'listing'){
            google.maps.event.addListener(item.marker, 'click', function () {
              const locationId = this._locationId;
              const $target = jQuery('[data-location-id="' + locationId + '"]');
              if (!$target.length) return;
              const offset = 120; // adjust for fixed header
              const top = $target.offset().top - offset;
              jQuery(window).scrollTop(top);
            });
          }

        });

        // Fit map to show all markers with sensible zoom handling
        if (validMarkerCount === 0) {
          // No markers: reset to a sensible default view
          map.setCenter({ lat: -27.3817412, lng: 152.8283958 });
          map.setZoom(10);
        } else if (validMarkerCount === 1 && firstPosition) {
          // Single marker: center map and set a reasonable zoom
          adjustMapCenter(map);
          //map.setCenter(firstPosition);
          //map.setZoom(12);
        } else {
          // Multiple markers: fit bounds and clamp the resulting zoom
          adjustMapCenter(map);
          jQuery(window).on('resize', function () {
            adjustMapCenter(map);
          });
          /*
          try {
            if (map.fitBounds.length >= 2) {
              map.fitBounds(bounds, 60);
            } else {
              map.fitBounds(bounds);
            }
          } catch (e) {
            map.fitBounds(bounds);
          }
          */
         
          // Clamp zoom after bounds settle
          google.maps.event.addListenerOnce(map, 'idle', function() {
            var maxZoom = 15;
            var minZoom = 6;
            var currentZoom = map.getZoom();
            if (currentZoom > maxZoom) map.setZoom(maxZoom);
            if (currentZoom < minZoom) map.setZoom(minZoom);
          });
        }

        return;
      }

    } // ENDFUNC

    function initialiseMapAndMarkers(mapData) {
      // First initialize the map
      initialiseMap();

      // Then create markers after map is ready
      setTimeout(function() {
        createMarkers(mapData);
      }, 100);

    } // ENDFUNC

    function checkGoogleMaps() {
      // Check if the Google Maps API is available
      if (typeof google !== 'undefined' && typeof google.maps !== 'undefined') {
        // Google Maps API is loaded, initialise the map and markers
        initialiseMapAndMarkers(mapData);
      } else {
        // Google Maps API is not loaded, retry after a delay
        setTimeout(checkGoogleMaps, 1000);
      }
    } // ENDFUNC

    checkGoogleMaps();
    ////////////////////////////////////////////////////////////////////////////////////

    bindPaginationEvents();

  });

}

function adjustMapCenter(map){
  const mapDiv = map.getDiv();
  const mapWidth = mapDiv.offsetWidth;
  const mapHeight = mapDiv.offsetHeight;
  const viewportWidth = window.innerWidth;
  if (viewportWidth >= 991) {
    map.fitBounds(bounds, {left: Math.floor(mapWidth * 0.5),top: 40,right: 40,bottom: 40});
  }else{
    map.fitBounds(bounds, {bottom: Math.floor(mapHeight * 0.5),left: 40,right: 40,top: 40});
  }
}


////////////////////////////////////////////////////////////////////////////////////
// Pan Control - Supports multiple panzoom instances (ACTIVE instance only)
////////////////////////////////////////////////////////////////////////////////////
var jsFloorPlanRotation = 0;

function panControl(selector = '.js-fp-panzoom.active') {
  const panzoomElements = document.querySelectorAll(selector);

  panzoomElements.forEach(panzoomElement => {

    // Prevent re-initialisation
    if (panzoomElement.panzoomInstance) {
      updatePanClasses(panzoomElement);
      return;
    }

    const panzoom = Panzoom(panzoomElement, {
      maxScale: 4,
      minScale: 0.5,
      step: 0.1
    });

    panzoom.setOptions({ disablePan: true });

    // Store instance on element
    panzoomElement.panzoomInstance = panzoom;

    // Find scoped container
    const container = panzoomElement.closest('.panzoom-container') || panzoomElement.parentElement;
    const zoomInButton  = container.querySelector('.js-zoom-in');
    const zoomOutButton = container.querySelector('.js-zoom-out');
    const resetButton   = container.querySelector('.js-reset-zoom');

    let lastScale = panzoom.getScale();

    panzoomElement.addEventListener('panzoomchange', () => {
      const currentScale = panzoom.getScale();
      if (currentScale !== lastScale) {
        lastScale = currentScale;
        setTimeout(() => updatePanClasses(panzoomElement), 300);
      }
    });

    if (zoomInButton) {
      zoomInButton.addEventListener('click', e => {
        e.preventDefault();
        panzoom.zoomIn();
      });
    }

    if (zoomOutButton) {
      zoomOutButton.addEventListener('click', e => {
        e.preventDefault();
        panzoom.zoomOut();
      });
    }

    if (resetButton) {
      resetButton.addEventListener('click', e => {
        e.preventDefault();
        panzoom.reset();
        resetRotation(panzoomElement);
      });
    }

    updatePanClasses(panzoomElement);
  });
}

function canPanNow(panzoomElement) {
  const img = panzoomElement.querySelector('img');
  if (!img) return false;
  const imgRect = img.getBoundingClientRect();
  const containerRect = panzoomElement.parentElement.getBoundingClientRect();
  const overflows =
    imgRect.left < containerRect.left ||
    imgRect.top < containerRect.top ||
    imgRect.right > containerRect.right ||
    imgRect.bottom > containerRect.bottom;
  return overflows;
}

function updatePanClasses(panzoomElement) {
  const panzoom = panzoomElement.panzoomInstance;
  if (!panzoom) return;

  if (canPanNow(panzoomElement)) {
    panzoom.setOptions({ disablePan: false });
    panzoomElement.classList.add('can-pan');
  } else {
    panzoom.setOptions({ disablePan: true });
    panzoomElement.classList.remove('can-pan');
  }
}

function resetRotation(panzoomElement) {
  if (jsFloorPlanRotation % 360 === 0) return;

  const img = panzoomElement.querySelector('img');
  if (!img) return;

  const normalized = jsFloorPlanRotation % 360;
  const delta = ((0 - normalized + 540) % 360) - 180;

  img.style.transition = 'transform 0.3s ease';
  img.style.transform = `rotate(${normalized + delta}deg)`;

  img.addEventListener('transitionend', function handler() {
    img.style.transition = 'none';
    img.style.transform = 'rotate(0deg)';
    jsFloorPlanRotation = 0;
    img.removeEventListener('transitionend', handler);
    updatePanClasses(panzoomElement);
  });
}


////////////////////////////////////////////////////////////////////////////////////
// Document Ready
////////////////////////////////////////////////////////////////////////////////////
jQuery( document ).ready(function($) {

  ////////////////////////////////////////////////////////////////////////////////////
  // Anchor Link Hash
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click', 'a', function() {

    const href = $(this).attr('href');
    if (!href) return;
    
    if (jQuery(this).hasClass('chosen-single') || jQuery(this).hasClass('js-zoom-control')) {
      return;
    }
    var hash = href.split('#');
    nous_anchor_link_hash(hash[1]);

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Site Wide Variables
  ////////////////////////////////////////////////////////////////////////////////////
  var nousThemeName = $('body').attr('data-nous-theme');
  var googleMapStyles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]}];

  ////////////////////////////////////////////////////////////////////////////////////
  // Determine if is retina device
  ////////////////////////////////////////////////////////////////////////////////////
  function isRetinaDisplay() {
    if (window.matchMedia) {
      var mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
      return (mq && mq.matches || (window.devicePixelRatio > 1));
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Generate Munchkin Hash
  ////////////////////////////////////////////////////////////////////////////////////
  function generate_munchkin_hash(email) {

    return $.ajax({
      type: "POST",
      url: '/wp-admin/admin-ajax.php',
      data: 'email=' + email + '&action=generate_munchkin_hash',
      dataType: 'json',
    });

  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Google Maps Init
  ////////////////////////////////////////////////////////////////////////////////////
  function init_google_map() {

    ////////////////////////////////////////////////////////////////////////////////////
    // Each Google Map
    ////////////////////////////////////////////////////////////////////////////////////
    $( '.js-init-google-map' ).each(function( index ) {

        ////////////////////////////////////////////////////////////////////////////////////
        // Variables
        ////////////////////////////////////////////////////////////////////////////////////
        var myLatLng = {lat: $(this).data('lat'), lng: $(this).data('lng')};
        // var mapInfoWindow = $(this).attr('data-info-window');
        // var markerIcon = new google.maps.MarkerImage('/wp-content/themes/' + nousThemeName + '/assets/img/map-marker.png', null, null, null, new google.maps.Size(30,40));


        ////////////////////////////////////////////////////////////////////////////////////
        // Create Map
        ////////////////////////////////////////////////////////////////////////////////////
        var map = new google.maps.Map(document.getElementById($(this).attr('id')), {
          zoom: 12,
          center: myLatLng,
          styles: googleMapStyles
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Create Marker
        ////////////////////////////////////////////////////////////////////////////////////
        var marker = new google.maps.Marker({
          position: myLatLng,
          map: map,
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Create Info Window
        ////////////////////////////////////////////////////////////////////////////////////
        var infowindow = new google.maps.InfoWindow({
          content: mapInfoWindow,
          // pixelOffset: new google.maps.Size(5, 20)
        });
        infowindow.open(map, marker);

    }); // END EACH

  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Onload Functionality
  ////////////////////////////////////////////////////////////////////////////////////
  $(window).load(function() {

      ////////////////////////////////////////////////////////////////////////////////////
      // Hash Onload Scroll To Functionality
      ////////////////////////////////////////////////////////////////////////////////////
      if(window.location.hash) {

        setTimeout(function() {

          var hash = window.location.hash;
          hash = hash.split('#');

          // Deep-link to a specific virtual tour (e.g. #aura-sunshine-coast-2 from a
          // display location card). Activate that tour, sync the dropdown, then
          // scroll the section using the standard sticky-header offset.
          // getElementById avoids jQuery selector parsing for hashes that may
          // contain characters with special meaning in CSS selectors.
          var vtTargetEl = document.getElementById(hash[1]);
          if (vtTargetEl && $(vtTargetEl).hasClass('js-virtual-tour') && $(vtTargetEl).closest('.section-hd-virtual-tour').length) {
            var $vtSection = $(vtTargetEl).closest('.section-hd-virtual-tour');
            var $vtSelect = $vtSection.find('.js-hd-virtual-tours');
            if ($vtSelect.length) {
              // chosen:updated re-renders the Chosen widget that wraps native selects
              // site-wide; safe no-op if Chosen isn't bound to this select.
              $vtSelect.val(hash[1]).trigger('chosen:updated').trigger('change');
            } else {
              $vtSection.find('.js-virtual-tour').removeClass('active');
              $(vtTargetEl).addClass('active');
            }
            nous_anchor_link_hash('hd-virtual-tour');
            return;
          }

          nous_anchor_link_hash(hash[1]);

        }, 500);

      } // END HASH

      ////////////////////////////////////////////////////////////////////////////////////
      // Initialize Google Map
      ////////////////////////////////////////////////////////////////////////////////////
      init_google_map();

      ////////////////////////////////////////////////////////////////////////////////////
      // Trunc8 Function
      ////////////////////////////////////////////////////////////////////////////////////
      $( '.js-trunc8' ).each(function( index ) {

        var lineCount = $(this).attr('data-trunc8-line');

        $(this).trunk8({
          lines: parseInt(lineCount)
        });

      });

  }); // END ONLOAD


  ////////////////////////////////////////////////////////////////////////////////////
  // Clear input on focus
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('focus', '.js-clear-input', function() {

    $(this).val('');

    return false;

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Initialize Marketo Instance
  ////////////////////////////////////////////////////////////////////////////////////
  // $.ajax({
  //   url: '//munchkin.marketo.net/munchkin.js',
  //   dataType: 'script',
  //   cache: true,
  //   success: function() {
  //     Munchkin.init('[KEY]');
  //   }
  // });

  ////////////////////////////////////////////////////////////////////////////////////
  // Save To Disk Function
  ////////////////////////////////////////////////////////////////////////////////////
  // function SaveToDisk(fileURL, fileName) {
  //     // for non-IE
  //     if (!window.ActiveXObject) {
  //         var save = document.createElement('a');
  //         save.href = fileURL;
  //         save.target = '_blank';
  //         save.download = fileName || 'unknown';

  //         var evt = new MouseEvent('click', {
  //             'view': window,
  //             'bubbles': true,
  //             'cancelable': false
  //         });
  //         save.dispatchEvent(evt);

  //         (window.URL || window.webkitURL).revokeObjectURL(save.href);
  //     }

  //     // for IE < 11
  //     else if ( !! window.ActiveXObject && document.execCommand)     {
  //         var _window = window.open(fileURL, '_blank');
  //         _window.document.close();
  //         _window.document.execCommand('SaveAs', true, fileName || fileURL)
  //         _window.close();
  //     }
  // }

  ////////////////////////////////////////////////////////////////////////////////////
  // Scroll To Event
  ////////////////////////////////////////////////////////////////////////////////////
  // $(document).on('click', '.js-scroll-to', function() {

  //   // Scroll to
  //   var scrollTo = $(this).attr('data-scroll-to');

  //   // Header Position Offset
  //   if($('.header-top').css('position') === 'fixed') {
  //     var headerHeight = $('.js-navbar-fixed-top').outerHeight();
  //   } else {
  //     var headerHeight = 0;
  //   }

  //   $('html, body').animate({
  //    scrollTop: $('*[data-scroll-element="' + scrollTo + '"]').offset().top
  //   }, 0);

  //   return false;

  // });

  ////////////////////////////////////////////////////////////////////////////////////
  // Marketo IE10 Bug fix
  ////////////////////////////////////////////////////////////////////////////////////
  (function () {
    'use strict';
    if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
      var msViewportStyle = document.createElement('style')
      msViewportStyle.appendChild(
        document.createTextNode(
          '@-ms-viewport{width:auto!important}'
        )
      )
      document.querySelector('head').appendChild(msViewportStyle)
    }
  })();

  ////////////////////////////////////////////////////////////////////////////////////
  // FAQ accordion toggle functionality
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click', '.js-panel', function() {

      $('.panel-collapse').removeClass('in');

      if($(this).parent('.panel').hasClass('active')) {
        $(this).parent('.panel').removeClass('active');
        $(this).siblings('.panel-collapse').removeClass('in');
      } else {
        $('.js-panel').parent('.panel').removeClass('active');
        $(this).parent('.panel').addClass('active');
        $(this).siblings('.panel-collapse').addClass('in');
      }

      return false;
  });

  ////////////////////////////////////////////////////////////////////////////////////
  // jQuery Validate Phone Method - Uses Google Lib
  ////////////////////////////////////////////////////////////////////////////////////
  $.validator.addMethod("validPhone", function(value, element) {
      if(value == '') { return true; }
      try {
          var phoneUtil = i18n.phonenumbers.PhoneNumberUtil.getInstance();
          var number = phoneUtil.parseAndKeepRawInput(value, 'AU');
          if(phoneUtil.isValidNumber(number)) {
              return true;
          } else {
              return false;
          }
      }
      catch(ex) {
          return false;
          console.log(ex);
      }
  }, "Please enter a valid phone number (including area code for land lines)");



  (function($) {
    function checkHeights() {
      // Run only for screens 992px and above
      if ($(window).width() < 992) return;

      $('.section-flexi-display-homes-carousel').each(function() {
        const $section = $(this);
        const $copy = $section.find('.flexi-display-homes-carousel-copy');
        const $title = $section.find('.flexi-display-homes-carousel-title');

        const copyHeight = $copy.outerHeight();
        const titleHeight = $title.outerHeight();

        const isCopyTall = copyHeight > 120;
        const isTitleTall = titleHeight > 40;

        // Remove old classes before adding a new one
        $section.removeClass('tall-top tall-bottom tall-both');

        if (isCopyTall && !isTitleTall) {
          $section.addClass('tall-top');
        } else if (!isCopyTall && isTitleTall) {
          $section.addClass('tall-bottom');
        } else if (isCopyTall && isTitleTall) {
          $section.addClass('tall-both');
        }
      });
    }

    // Run on load
    $(window).on('load', checkHeights);

    // Run at the end of resizing (debounced)
    let resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkHeights, 300); // runs 300ms after resize stops
    });
  })(jQuery);




  ////////////////////////////////////////////////////////////////////////////////////
  // Unified Gated PDF Download System
  // Handles: KC downloads, HD Range brochures, CMS-toggled PDF links
  ////////////////////////////////////////////////////////////////////////////////////
  (function($){
    if (!$('.js-nous-gated-modal').length) return;

    var state = {
      pdfUrl: null,
      formId: null,
      postId: null,
      title: null,
      fileType: null,
      autoDownload: false
    };

    var defaultFormId = (typeof NousGatedDownload !== 'undefined') ? NousGatedDownload.defaultFormId : 0;

    function openModal() {
      togglePageScroll('lock');
      $('.js-nous-gated-modal').show(300);
    }

    function closeModal() {
      togglePageScroll('unlock');
      $('.js-nous-gated-modal').hide(300);
      $('.js-nous-gated-modal__form-slot').empty();
      $('.js-nous-gated-modal__instruction').show();
      state = { pdfUrl: null, formId: null, postId: null, title: null, fileType: null, autoDownload: false };
    }

    // Close handlers
    $(document).on('click', '.js-nous-gated-modal__close', closeModal);
    $(document).on('click', '.js-nous-gated-modal', function(e) {
      if ($(e.target).is('.js-nous-gated-modal')) closeModal();
    });
    $(document).on('keydown', function(e) {
      if (e.key === 'Escape' && $('.js-nous-gated-modal').is(':visible')) closeModal();
    });

    ////////////////////////////////////////////////////////////////////////////////////
    // Core: open gated modal for a PDF
    ////////////////////////////////////////////////////////////////////////////////////
    function openGatedModal(pdfUrl, formId, postId, title, fileType, autoDownload) {
      state.pdfUrl       = pdfUrl;
      state.formId       = formId || defaultFormId;
      state.postId       = postId || null;
      state.title        = title || '';
      state.fileType     = fileType || '';
      state.autoDownload = autoDownload !== false;

      // Set modal title (Snippets override > auto-generated from PDF name)
      var staticTitle = (typeof NousGatedDownload !== 'undefined') ? NousGatedDownload.modalTitle : '';
      var modalTitle = staticTitle || (state.title ? "Download '" + state.title + "'" : 'Download Brochure');
      $('.js-nous-gated-modal__title').text(modalTitle);

      // Clone form template into slot
      var $tpl = $('.js-nous-gated-form-template[data-form-id="' + state.formId + '"]').first();
      if (!$tpl.length && state.formId !== defaultFormId) {
        // Fallback to default form
        $tpl = $('.js-nous-gated-form-template[data-form-id="' + defaultFormId + '"]').first();
        state.formId = defaultFormId;
      }
      if (!$tpl.length) {
        $('.js-nous-gated-modal__form-slot').html('<p>Form not found.</p>');
        openModal();
        return;
      }

      var $formHtml = $tpl.children().clone(true, true);
      $('.js-nous-gated-modal__form-slot').html($formHtml);

      // Reset form
      if (typeof window.gformResetForm === 'function' && state.formId) {
        window.gformResetForm(state.formId);
      }

      // Populate ALL hidden field variants (legacy kc_, hd_, and new gated_ prefixes)
      var $slot = $('.js-nous-gated-modal__form-slot');
      var fieldMap = {
        'js-kc-post-id': state.postId, 'js-hd-post-id': state.postId, 'js-gated-post-id': state.postId,
        'js-kc-download-url': state.pdfUrl, 'js-hd-download-url': state.pdfUrl, 'js-gated-download-url': state.pdfUrl,
        'js-kc-title': state.title, 'js-hd-title': state.title, 'js-gated-title': state.title,
        'js-kc-file-type': state.fileType, 'js-hd-file-type': state.fileType, 'js-gated-file-type': state.fileType
      };
      $.each(fieldMap, function(cls, val) {
        if (val) $slot.find('input.' + cls).val(val);
      });

      $(document).trigger('gform_post_render', [state.formId, 1]);
      clearGfLoadingState(state.formId);
      openModal();
    }

    ////////////////////////////////////////////////////////////////////////////////////
    // Handler 1: Explicit gated download buttons (KC, HD Range, new unified)
    ////////////////////////////////////////////////////////////////////////////////////
    $(document).on('click', '.js-nous-gated-download, .js-knowledge_centre_download, .js-hd_range_brochure_download', function(e) {
      e.preventDefault();
      var autoDownload = $(this).data('auto-download') == 1;
      openGatedModal(
        $(this).data('url'),
        parseInt($(this).data('form-id'), 10),
        parseInt($(this).data('post-id'), 10),
        $(this).data('title'),
        $(this).data('file-type'),
        autoDownload
      );
    });

    ////////////////////////////////////////////////////////////////////////////////////
    // Handler 2: CMS-toggled gating via data-gated-pdf attribute
    // Catches: PDF links inside [data-gated-pdf] containers (block-level toggle)
    //          and individual links with data-gated-pdf (per-card toggle)
    ////////////////////////////////////////////////////////////////////////////////////
    $(document).on('click', '[data-gated-pdf] a[href$=".pdf"], [data-gated-pdf] a[href$=".PDF"], a[data-gated-pdf][href$=".pdf"], a[data-gated-pdf][href$=".PDF"]', function(e) {
      var $link = $(this);

      // Skip if already handled by explicit trigger above
      if ($link.hasClass('js-nous-gated-download') || $link.hasClass('js-knowledge_centre_download') || $link.hasClass('js-hd_range_brochure_download')) return;

      e.preventDefault();

      var pdfUrl = $link.attr('href');
      var $container = $link.closest('[data-gated-pdf]');
      var title  = $link.data('title') || $container.data('gated-title') || document.title || '';
      var formId = parseInt($link.data('form-id'), 10) || parseInt($container.data('form-id'), 10) || defaultFormId;

      openGatedModal(pdfUrl, formId, null, title, 'pdf', true);
    });

    ////////////////////////////////////////////////////////////////////////////////////
    // Auto-download PDF after successful form submission
    ////////////////////////////////////////////////////////////////////////////////////
    $(document).on('gform_confirmation_loaded', function(event, formId) {
      if (state.formId && parseInt(formId, 10) === parseInt(state.formId, 10) && state.pdfUrl && state.autoDownload) {
        window.open(state.pdfUrl, '_blank');
      }
      // Hide instruction text
      $('.js-nous-gated-modal__instruction').hide();
    });

  })(jQuery);


  ////////////////////////////////////////////////////////////////////////////////////
  // Clear Gravity Forms loading state (shared utility)
  ////////////////////////////////////////////////////////////////////////////////////
  function clearGfLoadingState(formId) {
    var $form = jQuery('#gform_' + formId);
    if (!$form.length) return;
    $form.find('.gform_ajax_spinner, .gform-loader, .gform-spinner, .gform-loader-spinner').remove();
    $form.find('input[type="submit"], button[type="submit"]').prop('disabled', false).removeAttr('disabled');
    $form.removeClass('gform_submitting');
    $form.removeAttr('aria-busy');
    $form.find('.gform_footer, .gform_page_footer').css('opacity', '');
  }


  ////////////////////////////////////////////////////////////////////////////////////
  // Toggle scroll lock on modal open/close
  ////////////////////////////////////////////////////////////////////////////////////
  function togglePageScroll(action) {
    if (action === 'lock') {
      jQuery('body').addClass('hd-modal-open');
    }
    if (action === 'unlock') {
      jQuery('body').removeClass('hd-modal-open');
    }
  }

  // Overrides jQuery's scrollTop() while modal is open
  (function($){
    const originalScrollTop = $.fn.scrollTop;
    $.fn.scrollTop = function(value){
      if (value !== undefined && $('body').hasClass('hd-modal-open')) {
        return this;
      }
      return originalScrollTop.apply(this, arguments);
    };
  })(jQuery);




  ////////////////////////////////////////////////////////////////////////////////////
  // RANGE SLIDER
  ////////////////////////////////////////////////////////////////////////////////////
  (function ($) {

    function initRangeSlider($wrap) {
      let lastEmittedMin = null;
      let lastEmittedMax = null;

      let editingMin = false;
      let editingMax = false;

      const $min  = $wrap.find('.js-range-slider-min');
      const $max  = $wrap.find('.js-range-slider-max');
      const $fill = $wrap.find('.js-range-slider-fill');

      const $minDisp = $wrap.find('.js-range-slider-min-display');
      const $maxDisp = $wrap.find('.js-range-slider-max-display');

      if (!$min.length || !$max.length) return;

      const MIN  = parseFloat($wrap.data('min'));
      const MAX  = parseFloat($wrap.data('max'));
      const STEP = parseFloat($wrap.data('step'));
      const MIN_GAP = parseFloat($wrap.data('minGap')) || 0; // reads gap between thumbs

      const formatType = ($wrap.data('format') || 'currency').toString();
      const prefix = ($wrap.data('prefix') ?? '').toString();
      const suffix = ($wrap.data('suffix') ?? '').toString();
      const useDisplayMultiplier = String($wrap.data('useDisplayMultiplier') || '').toLowerCase() === 'true';
      const DISPLAY_MULTIPLIER = useDisplayMultiplier
        ? (parseFloat($wrap.data('displayMultiplier')) || 9.29)
        : 1;

      const clamp = (v,a,b) => Math.min(b, Math.max(a, v));
      const snap = (v) => {
        const snapped = Math.round(v / STEP) * STEP;
        return Number(snapped.toFixed(6)); // Prevent floating point errors
      };
      //const fmtN  = (n) => Number(n).toLocaleString('en-US');
      //const fmt   = (n) => `${prefix}${fmtN(n)}${suffix}`;

      function formatValue(n) {
        const displayVal = Math.round(n * DISPLAY_MULTIPLIER);

        if (formatType === 'raw') return String(displayVal) + suffix;
        if (formatType === 'number') return displayVal.toLocaleString('en-US') + suffix;

        return `${prefix}${displayVal.toLocaleString('en-US')}${suffix}`;
      }

      function updateFill(minVal, maxVal) {
        if (!$fill.length) return;
        const range = MAX - MIN;
        const left  = ((minVal - MIN) / range) * 100;
        const right = ((maxVal - MIN) / range) * 100;

        $fill.css({
          left: left + '%',
          width: (right - left) + '%'
        });
      }

      function render(e) {
        let minVal = snap(parseFloat($min.val()));
        let maxVal = snap(parseFloat($max.val()));

        minVal = clamp(minVal, MIN, MAX);
        maxVal = clamp(maxVal, MIN, MAX);

        // ensure init respects minimum gap
        if (MIN_GAP > 0) {
          if (minVal + MIN_GAP > maxVal) {
            if ($(e.target).is($min)) {
              minVal = maxVal - MIN_GAP;
              minVal = clamp(minVal, MIN, MAX);
              $min.val(minVal);
            } else {
              maxVal = minVal + MIN_GAP;
              maxVal = clamp(maxVal, MIN, MAX);
              $max.val(maxVal);
            }
          }
        } else {
          // Allow Overlap
          if (minVal > maxVal) {
            if ($(e.target).is($min)) {
              minVal = maxVal;
              $min.val(minVal);
            } else {
              maxVal = minVal;
              $max.val(maxVal);
            }
          }
        }

        if ($minDisp.length && !editingMin) $minDisp.val(formatValue(minVal));
        if ($maxDisp.length && !editingMax) $maxDisp.val(formatValue(maxVal));

        updateFill(minVal, maxVal);

        // Run only when values change
        if (minVal !== lastEmittedMin || maxVal !== lastEmittedMax) {
          lastEmittedMin = minVal;
          lastEmittedMax = maxVal;

          $wrap[0].dispatchEvent(
            new CustomEvent('range-slider:change', {
              bubbles: true,
              detail: { min: minVal, max: maxVal, source: e?.source || 'thumb' }
            })
          );
        }
      }

      // Ensure attributes match data
      $min.add($max).attr({ min: MIN, max: MAX, step: STEP });

      // Initialize using current values set in PHP
      const initMin = parseFloat($min.val());
      const initMax = parseFloat($max.val());

      $min.val(snap(clamp(isNaN(initMin) ? MIN : initMin, MIN, MAX)));
      $max.val(snap(clamp(isNaN(initMax) ? MAX : initMax, MIN, MAX)));

      if (MIN_GAP > 0) {
        let minVal = parseFloat($min.val());
        let maxVal = parseFloat($max.val());

        if (minVal + MIN_GAP > maxVal) {
          maxVal = clamp(minVal + MIN_GAP, MIN, MAX);
          $max.val(maxVal);
        }
      }


      // Re-initialize
      $min.off('.rangeslider').on('input.rangeslider change.rangeslider', render);
      $max.off('.rangeslider').on('input.rangeslider change.rangeslider', render);

      // ------------------------------
      // Rail click / tap to move nearest thumb (bind to wrapper so events always fire)
      // ------------------------------
      const $rail = $wrap.find('.range-slider__rail');

      function valueFromClientX(clientX) {
        const rect = $rail[0].getBoundingClientRect();
        const x = Math.min(rect.right, Math.max(rect.left, clientX));
        const pct = (x - rect.left) / rect.width;
        const raw = MIN + pct * (MAX - MIN);
        return snap(clamp(raw, MIN, MAX));
      }

      function handleRailAction(e) {

        // only react when clicking the rail
        if (!$(e.target).closest('.range-slider__rail').length) return;

        // ignore clicks on the thumbs
        if ($(e.target).is('input[type="range"]')) return;

        // restrict to left click only
        if (e.type === 'click' && e.button !== 0) return;               // left click only
        if (e.type === 'pointerdown' && e.pointerType === 'mouse' && e.button !== 0) return;
        
        const clickedVal = valueFromClientX(e.clientX);
        const curMin = parseFloat($min.val());
        const curMax = parseFloat($max.val());
        const moveMin = Math.abs(clickedVal - curMin) <= Math.abs(clickedVal - curMax);

        if (moveMin) {
          const limit = (MIN_GAP > 0) ? (curMax - MIN_GAP) : curMax;
          $min.val(Math.min(clickedVal, limit));
          render({ target: $min[0], source: 'rail' });
        } else {
          const limit = (MIN_GAP > 0) ? (curMin + MIN_GAP) : curMin;
          $max.val(Math.max(clickedVal, limit));
          render({ target: $max[0], source: 'rail' });
        }
      }

      // bind to wrapper instead of rail
      $wrap.off('.railclick')
          .on('pointerdown.railclick click.railclick', handleRailAction);
      // ------------------------------


      // ======================================
      // Allow typing into min/max display boxes
      // ======================================
      function parseNumber(val) {
        return parseFloat(String(val).replace(/[^\d.]/g, '')) || 0;
      }

      //function parseNumber(val) {
        //return parseFloat(String(val).replace(/[^\d.]/g, ''));
      //}

      function commitMinFromDisplay() {
        let v = parseNumber($minDisp.val());
        if (isNaN(v)) return render({ target: $min[0] });

        if (useDisplayMultiplier) v = v / DISPLAY_MULTIPLIER;

        v = snap(clamp(v, MIN, MAX));

        const curMax = parseFloat($max.val());
        if (MIN_GAP > 0) v = Math.min(v, curMax - MIN_GAP);

        $min.val(v);
        render({ target: $min[0] });
      }

      function commitMaxFromDisplay() {
        let v = parseNumber($maxDisp.val());
        if (isNaN(v)) return render({ target: $max[0] });

        if (useDisplayMultiplier) v = v / DISPLAY_MULTIPLIER;

        v = snap(clamp(v, MIN, MAX));

        const curMin = parseFloat($min.val());
        if (MIN_GAP > 0) v = Math.max(v, curMin + MIN_GAP);

        $max.val(v);
        render({ target: $max[0] });
      }

      $minDisp.on('change keyup', function () {
        const typed = parseNumber(this.value);
        let v = useDisplayMultiplier ? (typed / DISPLAY_MULTIPLIER) : typed;

        v = snap(clamp(v, MIN, MAX));

        const curMax = parseFloat($max.val());
        if (MIN_GAP > 0) v = Math.min(v, curMax - MIN_GAP);

        $min.val(v);
        render({ target: $min[0] });
      });

      $maxDisp.on('change keyup', function () {
        const typed = parseNumber(this.value);
        let v = useDisplayMultiplier ? (typed / DISPLAY_MULTIPLIER) : typed;

        v = snap(clamp(v, MIN, MAX));

        const curMin = parseFloat($min.val());
        if (MIN_GAP > 0) v = Math.max(v, curMin + MIN_GAP);

        $max.val(v);
        render({ target: $max[0] });
      });

      // Make displays editable (remove readonly in HTML too)
      $minDisp.on('focus', function () {
        editingMin = true;
        const raw = parseFloat($min.val());
        $(this).val(useDisplayMultiplier ? Math.round(raw * DISPLAY_MULTIPLIER) : raw);
        this.select();
      })
        .on('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            editingMin = false;
            commitMinFromDisplay();
            this.blur();
          }
          if (e.key === 'Escape') {
            e.preventDefault();
            editingMin = false;
            render({ target: $min[0] });
            this.blur();
          }
        })
        .on('blur', function () {
          editingMin = false;
          commitMinFromDisplay();
        });

      $maxDisp.on('focus', function () {
        editingMax = true;
        const raw = parseFloat($max.val());
        $(this).val(useDisplayMultiplier ? Math.round(raw * DISPLAY_MULTIPLIER) : raw);
        this.select();
      })
        .on('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            editingMax = false;
            commitMaxFromDisplay();
            this.blur();
          }
          if (e.key === 'Escape') {
            e.preventDefault();
            editingMax = false;
            render({ target: $max[0] });
            this.blur();
          }
        })
        .on('blur', function () {
          editingMax = false;
          commitMaxFromDisplay();
        });
      // ------------------------------

      render({ target: $min[0] });
    }

    // INITIALIZE EACH RANGE SLIDER FIELD
    $('.js-range-slider').each(function () {
      initRangeSlider($(this));
    });


  })(jQuery);

  ////////////////////////////////////////////////////////////////////////////////////
  // PDF Links: Force target="_blank" and rel="noopener noreferrer"
  // Safety net for WYSIWYG content and any links missed server-side
  ////////////////////////////////////////////////////////////////////////////////////
  document.querySelectorAll('a[href$=".pdf"], a[href$=".PDF"]').forEach(function(link) {
    if (!link.getAttribute('target')) {
      link.setAttribute('target', '_blank');
    }
    if (!link.getAttribute('rel') || link.getAttribute('rel').indexOf('noopener') === -1) {
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });




}); //document ready


////////////////////////////////////////////////////////////////////////////////////
// Flickity safety net — catch any [data-flickity] carousels that auto-init missed
// and fix lazy-loaded images inside Flickity carousels (lazy + transforms = deadlock)
////////////////////////////////////////////////////////////////////////////////////
function init_flickity_safety_net() {
  // 1. Catch carousels that auto-init may have missed
  document.querySelectorAll('[data-flickity]:not(.flickity-enabled)').forEach(function(elem) {
    var options = {};
    try {
      options = JSON.parse(elem.getAttribute('data-flickity'));
    } catch (e) {}
    new Flickity(elem, options);
  });

  // 2. Fix lazy-loaded images inside Flickity carousels.
  //    Flickity positions cells via CSS transforms, so the browser's lazy-loading
  //    IntersectionObserver may never consider off-screen cells as "near viewport".
  //    Swap loading="lazy" → "eager" and trigger a Flickity resize.
  document.querySelectorAll('.flickity-enabled').forEach(function(carousel) {
    var lazyImgs = carousel.querySelectorAll('img[loading="lazy"]');
    if (!lazyImgs.length) return;
    lazyImgs.forEach(function(img) { img.loading = 'eager'; });
    var flkty = Flickity.data(carousel);
    if (flkty) { flkty.resize(); }
  });
}

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Calendly password gate
// Validates the entered password server-side; the booking iframe is only returned
// (and injected) once the correct password is supplied.
////////////////////////////////////////////////////////////////////////////////////
function flexi_calendly_block() {
  var ajaxUrl = window.location.origin + '/wp-admin/admin-ajax.php';

  document.querySelectorAll('.js-calendly-gate').forEach(function (gate) {
    var form = gate.querySelector('.js-calendly-gate-form');
    var input = gate.querySelector('.js-calendly-gate-input');
    var errorEl = gate.querySelector('.js-calendly-gate-error');
    var submitBtn = gate.querySelector('.js-calendly-gate-submit');
    // Result sits beside the gate panel (not inside it) so the embed renders full width.
    var result = gate.parentNode ? gate.parentNode.querySelector('.js-calendly-gate-result') : null;

    if (!form || !input || !result) { return; }

    var submitLabel = submitBtn ? submitBtn.textContent : '';

    function showError(message) {
      if (errorEl) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
      input.classList.add('is-invalid');
    }

    function clearError() {
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
      input.classList.remove('is-invalid');
    }

    input.addEventListener('input', clearError);

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Send the raw value (no trim) so passwords with intentional whitespace
      // still match the stored value server-side; only the empty check is trimmed.
      var password = input.value;
      if (!password.trim()) {
        showError('Please enter the password.');
        input.focus();
        return;
      }

      clearError();
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Checking…';
      }

      var body = new URLSearchParams();
      body.append('action', 'hh_calendly_unlock');
      body.append('nonce', gate.getAttribute('data-nonce') || '');
      body.append('post_id', gate.getAttribute('data-post-id') || '');
      body.append('block_index', gate.getAttribute('data-block-index') || '');
      body.append('password', password);

      fetch(ajaxUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString()
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          if (data && data.success && data.data && data.data.html) {
            result.innerHTML = data.data.html;
            // Hide the whole gate panel; the embed now occupies the quote wrapper.
            gate.hidden = true;
          } else {
            var message = (data && data.data && data.data.message)
              ? data.data.message
              : 'Something went wrong. Please try again.';
            showError(message);
            input.focus();
          }
        })
        .catch(function () {
          showError('Something went wrong. Please try again.');
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = submitLabel;
          }
        });
    });
  });
}